<template>
  <div style="background-color: #f8f9fb">
    <!-- Diálogo de erro do filtro de empresa -->
    <v-dialog v-model="showErrorEmpresa" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showErrorEmpresa = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de empresa sem telefone cadastrado -->
    <v-dialog v-model="showNoPhoneDialog" persistent max-width="400">
      <v-card>
        <v-card-title> Aviso </v-card-title>
        <v-card-text class="d-flex justify-center text-center">
          <div>
            <p class="mb-2">
              A empresa <strong>{{ empresaSemTelefone }}</strong> não possui
              telefone cadastrado.
            </p>
            <p class="mb-0">Por favor, selecione outra empresa.</p>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showNoPhoneDialog = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Filtro de Empresa -->
    <v-container
      v-if="isAuthenticated && showFiltroEmpresa"
      style="background-color: #f8f9fb"
    >
      <v-col cols="12">
        <filtro-empresa
          @filtrar="filterDataEmpresa"
          @showError="showErrorEmpresa = true"
        ></filtro-empresa>
      </v-col>
    </v-container>
    <!-- Empresa selecionada (quando o filtro estiver oculto) -->

    <v-container
      v-if="isAuthenticated && !showFiltroEmpresa"
      style="background-color: #f8f9fb"
    >
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <div>
          <div class="subtitle-2 grey--text">Empresa selecionada</div>
          <div class="font-weight-bold">
            {{ selectedEmpresa ? selectedEmpresa : "Todas" }}
          </div>

          <div class="grey--text" v-bind="attrs" v-on="on" style="cursor: help">
            <v-icon small class="mr-1">mdi-phone</v-icon>
            {{ telefoneEmpresa || "Sem telefone cadastrado" }}
          </div>
        </div>
        <v-btn color="primary" small @click="showFiltroEmpresa = true">
          Selecionar outra empresa
        </v-btn>
      </v-col>
    </v-container>

    <base-material-card
      color="primary"
      icon="mdi-chat"
      class="v-card--material-stats"
    >
      <template v-slot:after-heading>
        <div class="ml-auto text-right">
          <div class="grey--text font-weight" style="font-size: 18px">Chat</div>
          <div class="subtitle-2 font-weight-light grey--text">
            Envio de mensagens via WhatsApp
          </div>
        </div>
      </template>

      <!-- Authentication Status -->
      <v-alert v-if="!isAuthenticated" type="info" outlined class="mx-4 mt-2">
        Autenticando...
      </v-alert>
      <v-alert v-if="authError" type="error" outlined class="mx-4 mt-2">
        Erro na autenticação: {{ authError }}
      </v-alert>

      <!-- Botão Novo Atendimento -->
      <div v-if="isAuthenticated" class="mb-4 d-flex justify-end px-4">
        <v-btn
          color="primary"
          @click="showNewAttendanceDialog = true"
          :disabled="!empresaSelecionada"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          Novo Atendimento
        </v-btn>
        <v-btn
          v-if="isAdmin"
          color="warning"
          @click="showDialogFinalizarProtocolosCampanha = true"
          :disabled="!empresaSelecionada"
        >
          <v-icon left>mdi-close</v-icon>
          Finalizar Protocolos
        </v-btn>
      </div>

      <!-- Layout Principal: Lista de Protocolos (esquerda) e Chat (direita) -->
      <v-container v-if="isAuthenticated" fluid class="pt-0">
        <v-row class="mt-2">
          <!-- Coluna Esquerda: Lista de Protocolos -->
          <v-col
            :cols="12"
            :md="showingClientDetails ? 3 : 4"
            v-if="!showingClientDetails"
          >
            <!-- Lista de Protocolos -->
            <v-card
              outlined
              class="protocols-card"
              style="
                height: calc(100vh - 200px);
                display: flex;
                flex-direction: column;
              "
            >
              <!-- Título e Campo de Busca -->
              <div
                class="pa-3"
                style="flex-shrink: 0; border-bottom: 1px solid #e0e0e0"
              >
                <div class="d-flex align-center mb-3">
                  <span class="subtitle-1 font-weight-bold">Protocolos</span>
                  <v-spacer></v-spacer>
                  <!-- Filtro de Status -->
                  <v-select
                    v-model="protocolStatusFilter"
                    :items="statusFilterOptions"
                    item-text="label"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    style="max-width: 140px"
                    class="mr-2"
                  >
                    <template v-slot:selection="{ item }">
                      <v-icon small left :color="item.color">
                        {{ item.icon }}
                      </v-icon>
                      <span class="caption">{{ item.label }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-icon small left :color="item.color">
                        {{ item.icon }}
                      </v-icon>
                      <span>{{ item.label }}</span>
                    </template>
                  </v-select>

                  <!-- Seleção de Fila -->
                  <v-menu
                    v-model="filaMenu"
                    bottom
                    offset-y
                    transition="fade-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                        class="ml-1"
                        :disabled="!filas || !filas.length"
                        title="Selecionar fila de atendimento"
                      >
                        <v-icon left small>mdi-cog-outline</v-icon>
                        <span
                          class="caption text-truncate"
                          style="max-width: 140px"
                        >
                          {{
                            filaSelecionada
                              ? filaSelecionada.nomeFila
                              : "Fila padrão"
                          }}
                        </span>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="fila in filas"
                        :key="fila.id"
                        @click="onSelecionarFila(fila)"
                      >
                        <v-list-item-content>
                          <v-list-item-title class="caption">
                            {{ fila.nomeFila }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon v-if="selectedFilaId === fila.id">
                          <v-icon small color="primary">mdi-check</v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

                <!-- Campo de busca -->
                <v-text-field
                  v-model="protocolSearch"
                  label="Filtrar por protocolo ou contato"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>

                <div class="mt-3 d-flex align-center justify-space-between">
                  <v-chip
                    :color="meusAtendimentos ? 'primary' : '#4A4A4A'"
                    :text-color="'white'"
                    @click="
                      meusAtendimentos = !meusAtendimentos;
                      init();
                    "
                    link
                  >
                    <v-icon
                      class="mr-2"
                      :color="meusAtendimentos ? 'white' : 'white'"
                    >
                      mdi-account
                    </v-icon>
                    Meus Atendimentos
                  </v-chip>
                  <v-btn
                    text
                    elevation="0"
                    class="mr-2"
                    small
                    @click="fetchOpenProtocols"
                    :loading="loadingProtocols"
                    title="Atualizar protocolos"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    Atualizar
                  </v-btn>
                </div>
              </div>
              <!-- Lista de Protocolos -->
              <div
                style="
                  flex: 1;
                  overflow: hidden;
                  display: flex;
                  flex-direction: column;
                  min-height: 0;
                "
              >
                <v-skeleton-loader
                  v-if="loadingProtocols"
                  type="list-item-three-line"
                ></v-skeleton-loader>
                <div
                  v-else
                  class="protocols-list-container"
                  style="flex: 1; overflow-y: auto"
                >
                  <v-list dense class="py-0">
                    <v-list-item
                      v-for="protocol in filteredProtocols"
                      :key="protocol.protocolo"
                      @click="selectProtocol(protocol)"
                      :class="{
                        'primary lighten-5':
                          currentProtocol === protocol.protocolo,
                      }"
                      class="px-3"
                      style="cursor: pointer; border-bottom: 1px solid #e0e0e0"
                    >
                      <v-list-item-content class="py-2">
                        <!-- Telefone com badge de alerta -->
                        <v-list-item-title
                          class="font-weight-bold mb-2 d-flex align-center justify-space-between"
                          style="min-height: 36px"
                        >
                          <div class="d-flex align-center">
                            <v-icon small color="primary" class="mr-1"
                              >mdi-phone</v-icon
                            >
                            <span>{{ protocol.numeroDoContato }}</span>
                          </div>

                          <v-badge
                            v-if="protocol.alerta"
                            color="red"
                            overlap
                            class="mr-4"
                            dot
                          >
                            <v-icon small>mdi-bell</v-icon>
                          </v-badge>
                        </v-list-item-title>

                        <!-- Informações do cliente em destaque -->
                        <div
                          v-if="protocol.clienteId || protocol.clienteNome"
                          class="mb-2 pa-1 lighten-4 rounded"
                        >
                          <div
                            class="d-flex justify-space-between align-center"
                          >
                            <div
                              v-if="protocol.clienteNome"
                              class="text-truncate font-weight-medium"
                            >
                              <v-icon x-small color="primary" class="mr-1"
                                >mdi-account</v-icon
                              >
                              {{ protocol.clienteNome }}
                            </div>
                            <div
                              v-if="protocol.clienteId"
                              class="caption grey--text text--darken-1"
                            >
                              ID: {{ protocol.clienteId }}
                            </div>
                          </div>
                        </div>

                        <v-list-item-subtitle class="mt-0">
                          <div>
                            <!-- Protocolo e status -->
                            <div class="d-flex justify-space-between mb-1">
                              <div>
                                <strong>Protocolo:</strong>
                                {{ protocol.protocolo }}
                              </div>
                              <div>
                                <!-- Indicador de Participante -->
                                <v-chip
                                  v-if="protocol.visitante === loggedUserName"
                                  x-small
                                  color="#F2C94C"
                                  text-color="black"
                                >
                                  Participando
                                </v-chip>
                                <v-chip
                                  v-else-if="
                                    protocol.emAtendimento &&
                                    protocol.status === 'open'
                                  "
                                  x-small
                                  color="info"
                                >
                                  Em Atendimento
                                </v-chip>
                                <v-chip
                                  v-else
                                  x-small
                                  :color="
                                    protocol.status === 'open'
                                      ? 'success'
                                      : 'grey'
                                  "
                                >
                                  {{
                                    protocol.status === "open"
                                      ? "Aberto"
                                      : "Fechado"
                                  }}
                                </v-chip>
                              </div>
                            </div>

                            <!-- Data de abertura -->
                            <div class="caption">
                              <strong>Aberto em:</strong>
                              {{ formatDateBR(protocol.dataDeAbertura) }}
                              {{ protocol.horaDeAbertura }}
                            </div>
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="filteredProtocols.length === 0"
                      class="px-3"
                    >
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-center py-4">
                          {{
                            protocolSearch
                              ? "Nenhum protocolo encontrado com o filtro aplicado"
                              : "Nenhum protocolo encontrado"
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-card>
          </v-col>

          <!-- Coluna Direita: Chat -->
          <v-col :cols="12" md="8">
            <!-- Chat vazio quando não há protocolo selecionado -->
            <v-card
              v-if="!currentProtocol"
              outlined
              class="d-flex align-center justify-center"
              style="height: calc(100vh - 200px)"
            >
              <v-card-text class="text-center">
                <v-icon size="64" color="grey lighten-1"
                  >mdi-chat-outline</v-icon
                >
                <div class="headline mt-4 grey--text">
                  Selecione um protocolo para visualizar o chat
                </div>
              </v-card-text>
            </v-card>

            <!-- Chat History Section -->
            <v-card
              v-else
              outlined
              class="chat-card"
              style="
                height: calc(100vh - 200px);
                display: flex;
                flex-direction: column;
              "
            >
              <!-- Título fixo no topo -->
              <div
                class="pa-2"
                style="
                  flex-shrink: 0;
                  border-bottom: 1px solid #e0e0e0;
                  background-color: white;
                "
              >
                <v-row>
                  <!-- Informações do protocolo -->
                  <v-col cols="6">
                    <v-chip small class="mr-2">
                      <v-icon left x-small>mdi-identifier</v-icon>
                      Protocolo: {{ currentProtocol }}
                    </v-chip>
                    <v-chip
                      v-if="selectedProtocolData"
                      small
                      color="info"
                      text-color="white"
                    >
                      <v-icon left x-small>mdi-phone</v-icon>
                      {{ selectedProtocolData.contato }} -
                      {{ selectedProtocolData.numeroDoContato }}
                    </v-chip>
                  </v-col>
                  <v-col cols="6"> </v-col>
                  <!-- Botões de ação -->
                  <v-col cols="12" class="d-flex align-center justify-end">
                    <!-- Atualizar -->
                    <v-btn
                      text
                      elevation="0"
                      class="mr-2"
                      @click="refreshMessages"
                      :loading="loadingMessages"
                      x-small
                      title="Atualizar mensagens"
                    >
                      <v-icon x-small>mdi-refresh</v-icon>
                    </v-btn>

                    <!-- Detalhes do Cliente -->
                    <v-btn
                      :color="showingClientDetails ? 'error' : 'info'"
                      :outlined="!showingClientDetails"
                      elevation="2"
                      class="mr-2"
                      @click="toggleClientDetails"
                      :disabled="!currentProtocol"
                      x-small
                      :title="
                        showingClientDetails
                          ? 'Ocultar detalhes do cliente'
                          : 'Detalhes do cliente'
                      "
                    >
                      <v-icon left x-small>{{
                        showingClientDetails
                          ? "mdi-eye-off"
                          : "mdi-account-details"
                      }}</v-icon>
                      {{ showingClientDetails ? "Ocultar" : "Detalhes" }}
                    </v-btn>

                    <!-- Aceitar Atendimento -->
                    <v-btn
                      v-if="
                        !isCurrentUserAttendant && !isCurrentUserParticipant
                      "
                      color="warning"
                      elevation="2"
                      class="mr-2"
                      @click="abrirDialogTransferenciaFila"
                      x-small
                      title="Transferir Fila"
                    >
                      <v-icon left x-small>mdi-swap-horizontal</v-icon>
                      Transferir Fila
                    </v-btn>

                    <!-- Aceitar Atendimento -->
                    <v-btn
                      v-if="
                        !isCurrentUserAttendant && !isCurrentUserParticipant
                      "
                      color="success"
                      elevation="2"
                      class="mr-2"
                      @click="vincularAtendimento"
                      :loading="linkingAttendance"
                      x-small
                      title="Aceitar atendimento"
                    >
                      <v-icon left x-small>mdi-check-circle</v-icon>
                      Aceitar
                    </v-btn>

                    <!-- Menu de Ações -->
                    <v-menu
                      v-if="isCurrentUserAttendant || isCurrentUserParticipant"
                      offset-y
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          elevation="2"
                          v-bind="attrs"
                          v-on="on"
                          x-small
                        >
                          <v-icon left x-small>mdi-dots-vertical</v-icon>
                          Ações
                          <v-icon right x-small>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <!-- Arquivos Enviados -->
                        <v-list-item
                          v-if="
                            isCurrentUserAttendant || isCurrentUserParticipant
                          "
                          @click="showArquivosDialog = true"
                          :disabled="!currentProtocol"
                        >
                          <v-list-item-icon>
                            <v-icon small color="info">mdi-file-send</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Arquivos Enviados</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <!-- Transferir -->
                        <v-list-item
                          v-if="isCurrentUserAttendant"
                          @click="abrirDialogTransferencia"
                          :disabled="transferringAttendance"
                        >
                          <v-list-item-icon>
                            <v-icon small color="info"
                              >mdi-account-switch</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Transferir Atendente</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                          v-if="isCurrentUserAttendant"
                          @click="abrirDialogTransferenciaFila"
                        >
                          <v-list-item-icon>
                            <v-icon small color="info"
                              >mdi-swap-horizontal</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Transferir Fila</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>

                        <!-- Participante -->
                        <v-list-item
                          v-if="
                            isCurrentUserAttendant &&
                            (selectedProtocolData.visitante == null ||
                              !selectedProtocolData.visitante)
                          "
                          @click="abrirDialogParticipante"
                          :disabled="addingParticipant"
                        >
                          <v-list-item-icon>
                            <v-icon small color="success"
                              >mdi-account-plus</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Adicionar Participante</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>

                        <!-- Sair do Atendimento -->
                        <v-list-item
                          v-if="
                            isCurrentUserParticipant ||
                            (isCurrentUserAttendant &&
                              selectedProtocolData.visitante) ||
                            (isCurrentUserAttendant &&
                              !selectedProtocolData.visitante)
                          "
                          @click="
                            isCurrentUserAttendant &&
                            selectedProtocolData.visitante
                              ? confirmRemoveParticipant()
                              : confirmExitAttendance()
                          "
                          :disabled="
                            isCurrentUserAttendant
                              ? removingParticipant
                              : unlinkingAttendance
                          "
                        >
                          <v-list-item-icon>
                            <v-icon small color="warning">{{
                              isCurrentUserAttendant &&
                              selectedProtocolData.visitante
                                ? "mdi-account-minus"
                                : "mdi-exit-to-app"
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                isCurrentUserAttendant &&
                                selectedProtocolData.visitante
                                  ? "Remover Participante"
                                  : "Sair do Atendimento"
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <!-- Finalizar -->
                        <v-list-item
                          v-if="
                            isCurrentUserAttendant && !isCurrentUserParticipant
                          "
                          @click="confirmCloseProtocol"
                          :disabled="closingProtocol"
                        >
                          <v-list-item-icon>
                            <v-icon small color="error"
                              >mdi-close-circle</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Finalizar Protocolo</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </div>

              <!-- Área de mensagens (flexível) -->
              <div
                style="
                  flex: 1;
                  overflow-y: auto;
                  overflow-x: hidden;
                  min-height: 0;
                  padding: 12px;
                "
              >
                <v-skeleton-loader
                  v-if="loadingMessages"
                  type="list-item-three-line"
                  :loading="loadingMessages"
                ></v-skeleton-loader>

                <div v-else class="chat-container">
                  <div
                    v-if="
                      selectedProtocolData &&
                      selectedProtocolData.numeroDoContato
                    "
                    class="d-flex justify-center align-center my-1 mb-3"
                  >
                    <v-btn
                      @click="toggleHistoricalMessages"
                      :color="
                        showingHistoricalMessages ? 'secondary' : 'primary'
                      "
                      outlined
                      :loading="loadingMessages"
                      :disabled="loadingMessages"
                      small
                    >
                      <v-icon left>{{
                        showingHistoricalMessages
                          ? "mdi-chevron-up"
                          : "mdi-history"
                      }}</v-icon>
                      {{
                        showingHistoricalMessages
                          ? "Ocultar Histórico"
                          : "Carregar Histórico Completo"
                      }}
                    </v-btn>
                  </div>
                  <!-- Seção de mensagens históricas -->
                  <template
                    v-if="
                      historicalMessages.length > 0 && showingHistoricalMessages
                    "
                  >
                    <div class="text-center my-4">
                      <v-chip small outlined color="primary" class="px-4">
                        --- Histórico de mensagens ({{
                          historicalMessages.length
                        }}) ---
                      </v-chip>
                    </div>

                    <div
                      v-for="message in historicalMessages"
                      :key="'hist-' + message._id"
                      :class="[
                        'message-bubble mb-2 pa-2',
                        message.message_type === 'note'
                          ? 'note-message-historico'
                          : message.direction === 'outgoing'
                          ? 'outgoing-message-historico'
                          : 'incoming-message-historico',
                      ]"
                    >
                      <div
                        v-if="message.message_type === 'error'"
                        class="error--text"
                      >
                        <v-alert type="error" dense text>
                          {{ stripHtml(message.message) }}
                        </v-alert>
                      </div>
                      <div v-else-if="message.message_type === 'note'">
                        {{ stripHtml(message.message) }}
                      </div>
                      <div v-else>
                        {{ message.message }}
                      </div>
                      <div class="caption text-right">
                        {{ formatDate(message.createdAt) }}
                        <template
                          v-if="
                            message.direction === 'outgoing' &&
                            message.userInsert
                          "
                        >
                          <br />
                          <span class="font-italic"
                            >Enviado por: {{ message.userInsert }}</span
                          >
                        </template>
                      </div>
                      <!-- Status de leitura (apenas para mensagens enviadas) -->
                      <div
                        v-if="
                          message.direction === 'outgoing' &&
                          message.ack !== undefined &&
                          message.ack !== null
                        "
                        class="caption text-right mt-1"
                        :class="{
                          'success--text': message.isRead === true,
                          'info--text':
                            message.isDelivered === true &&
                            message.isRead !== true,
                          'grey--text': !message.isDelivered,
                          'error--text': message.readStatus === 'error',
                        }"
                      >
                        <!-- Status de leitura igual ao das mensagens normais -->
                        <template v-if="message.isRead === true">
                          <v-icon x-small color="success">
                            mdi-check-all
                          </v-icon>
                          <span class="ml-1">Lido</span>
                        </template>
                        <template v-else-if="message.isDelivered === true">
                          <v-icon x-small color="info"> mdi-check-all </v-icon>
                          <span class="ml-1">Entregue</span>
                        </template>
                        <template v-else-if="message.readStatus === 'error'">
                          <v-icon x-small color="error"
                            >mdi-alert-circle</v-icon
                          >
                          <span class="ml-1">Erro ao enviar</span>
                        </template>
                        <template v-else>
                          <v-icon x-small color="grey"> mdi-check </v-icon>
                          <span class="ml-1">Enviada</span>
                        </template>
                      </div>
                    </div>

                    <!-- Separador entre histórico e mensagens atuais -->
                    <div class="text-center my-4" v-if="messages.length > 0">
                      <v-chip small outlined color="success" class="px-4">
                        --- Mensagens atuais ---
                      </v-chip>
                    </div>
                  </template>

                  <!-- Mensagens atuais do protocolo -->
                  <div
                    v-for="message in messages"
                    :key="message._id"
                    :class="[
                      'message-bubble mb-2 pa-2',
                      message.message_type === 'note'
                        ? 'note-message'
                        : message.direction === 'outgoing'
                        ? 'outgoing-message'
                        : 'incoming-message',
                    ]"
                  >
                    <div
                      v-if="message.message_type === 'error'"
                      class="error--text"
                    >
                      <v-alert type="error" dense text>
                        {{ stripHtml(message.message) }}
                      </v-alert>
                    </div>
                    <div v-else-if="message.message_type === 'note'">
                      {{ stripHtml(message.message) }}
                    </div>
                    <div
                      v-else-if="message.message_type === 'file'"
                      class="file-message"
                    >
                      <!-- Imagem -->
                      <div
                        v-if="isImage(message.fileUrl || message.message)"
                        class="text-center"
                      >
                        <v-img
                          :src="message.fileUrl || message.message"
                          max-height="300"
                          contain
                          class="rounded"
                          @click="
                            openMediaPreview(message.fileUrl || message.message)
                          "
                          style="cursor: pointer"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <!-- Áudio -->
                      <div
                        v-else-if="isAudio(message.fileUrl || message.message)"
                        class="text-center"
                      >
                        <audio
                          controls
                          preload="metadata"
                          style="max-width: 100%"
                        >
                          <source :src="message.fileUrl || message.message" />
                          Seu navegador não suporta a reprodução de áudios.
                        </audio>
                      </div>

                      <!-- Vídeo -->
                      <div
                        v-else-if="isVideo(message.fileUrl || message.message)"
                        class="text-center"
                      >
                        <video
                          controls
                          preload="metadata"
                          class="rounded"
                          style="max-width: 100%; max-height: 300px"
                        >
                          <source :src="message.fileUrl || message.message" />
                          Seu navegador não suporta a reprodução de vídeos.
                        </video>
                      </div>

                      <!-- Outros arquivos (download) -->
                      <div v-else class="text-center media-container">
                        <v-icon class="media-icon mb-2" color="primary"
                          >mdi-file-document-outline</v-icon
                        >
                        <v-btn
                          small
                          outlined
                          color="primary"
                          :href="message.fileUrl || message.message"
                          target="_blank"
                        >
                          <v-icon left small>mdi-open-in-new</v-icon>
                          Abrir arquivo
                        </v-btn>
                      </div>
                    </div>
                    <div v-else>
                      {{ message.message }}
                    </div>
                    <div class="caption text-right">
                      {{ formatDate(message.createdAt) }}
                      <template
                        v-if="
                          message.direction === 'outgoing' && message.userInsert
                        "
                      >
                        <br />
                        <span class="font-italic"
                          >Enviado por: {{ message.userInsert }}</span
                        >
                      </template>
                    </div>
                    <!-- Status de leitura (apenas para mensagens enviadas) -->
                    <div
                      v-if="
                        message.direction === 'outgoing' &&
                        message.ack !== undefined &&
                        message.ack !== null
                      "
                      class="caption text-right mt-1"
                      :class="{
                        'success--text': message.isRead === true,
                        'info--text':
                          message.isDelivered === true &&
                          message.isRead !== true,
                        'grey--text': !message.isDelivered,
                        'error--text': message.readStatus === 'error',
                      }"
                    >
                      <template v-if="message.message_type === 'note'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer"
                            >
                              <template v-if="message.message_type === 'note'">
                                <v-icon x-small color="warning"
                                  >mdi-robot</v-icon
                                >
                                <span
                                  v-if="message.readAt"
                                  class="ml-1 caption"
                                >
                                  {{ formatDate(message.readAt) }}
                                </span>
                              </template>
                            </span>
                          </template>

                          <span>
                            Esta é uma informação privada e exibida apenas para
                            consulta interna.
                          </span>
                        </v-tooltip>
                      </template>

                      <!-- Lido (ACK 3) -->
                      <template v-else-if="message.isRead === true">
                        <v-icon x-small color="success"> mdi-check-all </v-icon>
                        <span class="ml-1">Lido</span>
                        <span v-if="message.readAt" class="ml-1 caption">
                          {{ formatDate(message.readAt) }}
                        </span>
                      </template>
                      <!-- Entregue (ACK 2) -->
                      <template v-else-if="message.isDelivered === true">
                        <v-icon x-small color="info"> mdi-check-all </v-icon>
                        <span class="ml-1">Entregue</span>
                        <span v-if="message.deliveredAt" class="ml-1 caption">
                          {{ formatDate(message.deliveredAt) }}
                        </span>
                      </template>
                      <!-- Erro (ACK -2) -->
                      <template v-else-if="message.readStatus === 'error'">
                        <v-icon x-small color="error">
                          mdi-alert-circle
                        </v-icon>
                        <span class="ml-1">Erro ao enviar</span>
                      </template>
                      <!-- Enviada (ACK 0 ou 3) -->
                      <template v-else>
                        <v-icon x-small color="grey"> mdi-check </v-icon>
                        <span class="ml-1">Enviada</span>
                      </template>
                    </div>
                  </div>

                  <div v-if="messages.length === 0" class="text-center pa-4">
                    Nenhuma mensagem encontrada
                  </div>
                  <div ref="chatBottomAnchor" class="chat-bottom-anchor"></div>
                </div>
              </div>

              <!-- Campo de envio fixo na parte inferior -->
              <div
                class="pa-2"
                style="
                  flex-shrink: 0;
                  border-top: 1px solid #e0e0e0;
                  background-color: white;
                "
              >
                <!-- Mensagem informativa quando não é o atendente -->
                <v-alert
                  v-if="
                    !isCurrentUserAttendant &&
                    selectedProtocolData &&
                    !isCurrentUserParticipant
                  "
                  type="info"
                  dense
                  text
                  class="mb-1 py-1"
                  style="font-size: 12px"
                >
                  Você precisa aceitar o atendimento para enviar mensagens neste
                  protocolo.
                </v-alert>
                <div
                  class="text-formatting-buttons mb-1 d-flex align-center"
                  v-if="isCurrentUserAttendant || isCurrentUserParticipant"
                >
                  <v-btn-toggle dense group class="elevation-0 rounded-lg mr-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('bold')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>Negrito</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('italic')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-italic</v-icon>
                        </v-btn>
                      </template>
                      <span>Itálico</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('underline')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-underline</v-icon>
                        </v-btn>
                      </template>
                      <span>Sublinhado</span>
                    </v-tooltip>
                  </v-btn-toggle>

                  <v-menu
                    v-model="showEmojiPicker"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small text v-bind="attrs" v-on="on" class="px-1">
                        <v-icon small>mdi-emoticon-outline</v-icon>
                      </v-btn>
                    </template>
                    <div class="emoji-picker-container">
                      <emoji-picker
                        @emoji-click="onEmojiClick"
                        class="light"
                      ></emoji-picker>
                    </div>
                  </v-menu>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on"></span>
                    </template>
                    <span>Inserir emoji</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        text
                        v-bind="attrs"
                        v-on="on"
                        @click="openFileAttachmentDialog"
                        :disabled="
                          !currentProtocol ||
                          (!isCurrentUserAttendant && !isCurrentUserParticipant)
                        "
                      >
                        <v-icon>mdi-paperclip</v-icon>
                      </v-btn>
                    </template>
                    <span>Anexar arquivo</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        text
                        v-bind="attrs"
                        v-on="on"
                        @click="openAudioDialog"
                        :disabled="
                          !currentProtocol ||
                          (!isCurrentUserAttendant && !isCurrentUserParticipant)
                        "
                      >
                        <v-icon>mdi-microphone</v-icon>
                      </v-btn>
                    </template>
                    <span>Gravar áudio</span>
                  </v-tooltip>
                </div>
                <div class="d-flex align-center message-input-area">
                  <v-textarea
                    ref="textareaRef"
                    v-model="freeTextMessage"
                    label="Digite sua mensagem"
                    rows="2"
                    hide-details
                    outlined
                    dense
                    auto-grow
                    :disabled="
                      !isCurrentUserAttendant && !isCurrentUserParticipant
                    "
                    style="flex: 1; max-height: 120px; overflow-y: auto"
                    @keydown.enter="handleEnter"
                  />

                  <v-btn
                    color="primary"
                    small
                    class="ml-2"
                    :loading="sendingMessage"
                    :disabled="
                      sendingMessage ||
                      !freeTextMessage?.trim() ||
                      (!isCurrentUserAttendant && !isCurrentUserParticipant)
                    "
                    @click="sendFreeTextMessageHandler"
                  >
                    Enviar
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col v-if="showingClientDetails" cols="12" md="4">
            <v-card
              outlined
              class="client-details-card"
              style="height: calc(100vh - 200px); overflow-y: auto"
            >
              <!-- Cabeçalho do card -->
              <v-card-title>
                <v-icon left color="primary">mdi-account-details</v-icon>
                Detalhes do Cliente
              </v-card-title>

              <!-- Conteúdo principal do card -->
              <v-card-text>
                <!-- Loading -->
                <div v-if="loadingClientInfo" class="text-center py-5">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <div class="mt-3">Carregando informações do cliente...</div>
                </div>

                <!-- Erro -->
                <div v-else-if="clientInfoError" class="text-center py-5 pt-12">
                  <v-alert type="error" outlined>
                    {{ clientInfoError }}
                  </v-alert>
                  <v-btn color="primary" @click="fetchClientInfo" class="mt-3">
                    <v-icon left>mdi-refresh</v-icon>
                    Tentar novamente
                  </v-btn>
                </div>

                <!-- Sem dados -->
                <div v-else-if="!clientInfo" class="text-center py-5">
                  <v-alert type="info" outlined>
                    Nenhuma informação disponível para este cliente.
                  </v-alert>
                </div>

                <!-- Dados do cliente -->
                <div v-else class="mt-12">
                  <!-- Seletor de cliente -->
                  <div v-if="clientsCount > 1" class="mb-4">
                    <div class="d-flex align-center mb-2">
                      <v-chip color="primary" small class="mr-2">
                        {{ clientsCount }} clientes encontrados
                      </v-chip>
                      <div class="caption">
                        Selecione um cliente para visualizar os detalhes
                      </div>
                    </div>
                    <v-select
                      v-model="selectedClientIndex"
                      :items="
                        clients.map((client, index) => ({
                          text: client.nome || `Cliente ${index + 1}`,
                          value: index,
                        }))
                      "
                      label="Selecione o cliente"
                      outlined
                      dense
                      @change="changeSelectedClient"
                      class="mb-2"
                      color="primary"
                      item-color="primary"
                      hide-details
                    ></v-select>
                  </div>

                  <!-- Informações básicas -->
                  <div class="mb-4">
                    <v-list-item>
                      <v-list-item-avatar
                        size="60"
                        color="primary"
                        class="white--text"
                      >
                        {{
                          clientInfo.nome
                            ? clientInfo.nome.charAt(0).toUpperCase()
                            : "?"
                        }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1">{{
                          clientInfo.nome || "Nome não informado"
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <div>
                            <strong>CPF:</strong>
                            {{ formatCpf(clientInfo.cpf) || "Não informado" }}
                          </div>
                          <div>
                            <strong>Idade:</strong>
                            {{ clientInfo.idade || "Não informada" }} anos
                          </div>
                          <div class="caption">
                            <strong>ID do Cliente:</strong>
                            {{
                              clientInfo.idCliente ||
                              clientInfo.Id ||
                              "Não informado"
                            }}
                          </div>
                        </v-list-item-subtitle>

                        <!-- Ações de contato do cliente (barra lateral direita) -->
                        <div class="mt-2 d-flex flex-wrap">
                          <v-btn
                            small
                            color="primary"
                            text
                            class="mr-2 mb-1"
                            @click="openEditClientContactDialogFromSidebar"
                          >
                            <v-icon left small>mdi-pencil</v-icon>
                            Editar contato
                          </v-btn>

                          <v-btn
                            small
                            color="secondary"
                            text
                            class="mb-1"
                            @click="openAddClientInteractionDialog"
                          >
                            <v-icon left small>mdi-message-plus</v-icon>
                            Adicionar interação
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider class="my-3"></v-divider>

                    <!-- Status do cliente -->
                    <div
                      class="d-flex align-center mb-3"
                      v-if="
                        clientInfo.falecimento &&
                        clientInfo.falecimento !== '1900-01-01'
                      "
                    >
                      <div class="subtitle-1 font-weight-medium">Status:</div>
                      <v-chip
                        :color="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                            ? 'error'
                            : 'success'
                        "
                        small
                        class="ml-2"
                        :text-color="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                            ? 'white'
                            : ''
                        "
                      >
                        {{
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== "1900-01-01"
                            ? "Falecido"
                            : "Ativo"
                        }}
                      </v-chip>
                      <div
                        v-if="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                        "
                        class="ml-2 caption"
                      >
                        Data: {{ formatDate(clientInfo.falecimento) }}
                      </div>
                    </div>
                  </div>
                  <v-expansion-panels v-model="panel">
                    <v-expansion-panel class="expansion-panel">
                      <v-expansion-panel-header>
                        <!-- Contratos -->
                        <div class="pt-0 subtitle-1 font-weight-medium">
                          Contratos ({{
                            clientInfo.contratos
                              ? clientInfo.contratos.length
                              : 0
                          }})
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content expand>
                        <!-- Lista de contratos -->
                        <div class="pt-0">
                          <v-expansion-panels>
                            <v-expansion-panel
                              v-for="contrato in clientInfo.contratos"
                              :key="contrato.id"
                              class="expansion-panel"
                            >
                              <v-expansion-panel-header>
                                <div>
                                  <div class="font-weight-medium">
                                    {{ contrato.tipo }}
                                  </div>
                                  <div class="caption">
                                    <v-chip
                                      x-small
                                      :color="
                                        contrato.status === 'Ativo'
                                          ? 'success'
                                          : 'red'
                                      "
                                      class="mr-1"
                                    >
                                      {{ contrato.status }}
                                    </v-chip>
                                    Ref: {{ contrato.referencia }}
                                  </div>
                                </div>
                              </v-expansion-panel-header>

                              <v-expansion-panel-content expand>
                                <v-divider></v-divider>

                                <!-- Detalhes simples -->
                                <div class="py-3">
                                  <div>
                                    <strong>Empresa:</strong>
                                    {{ contrato.empresa }}
                                  </div>
                                  <div>
                                    <strong>Data:</strong>
                                    {{ formatDate(contrato.dataContrato) }}
                                  </div>

                                  <!-- Informações de LTV -->
                                  <div v-if="contrato.ltv" class="mt-4">
                                    <v-divider class="my-1"></v-divider>
                                    <div class="subtitle-2 mb-1">
                                      Informações de LTV
                                    </div>

                                    <v-row dense class="py-2">
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Severidade:</strong>
                                          {{ contrato.ltv.severidade }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>LTV:</strong>
                                          {{ contrato.ltv.ltv?.toFixed(4) }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Débito Cliente:</strong> R$
                                          {{
                                            contrato.ltv.debitoCliente?.toFixed(
                                              2,
                                            )
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>% Aplicado:</strong>
                                          {{ contrato.ltv.percentualAplicado }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Desconto:</strong> R$
                                          {{
                                            contrato.ltv.desconto?.toFixed(2)
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Valor Final:</strong> R$
                                          {{
                                            contrato.ltv.valorFinal?.toFixed(2)
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <div class="caption">
                                          <strong>Oferta:</strong>
                                          {{ contrato.ltv.oferta }}
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </div>

                                <v-divider></v-divider>

                                <!-- Parcelas -->
                                <v-tabs
                                  v-model="activeTab"
                                  background-color="transparent"
                                  color="primary"
                                  grow
                                  class="mt-3"
                                >
                                  <v-tab>
                                    <v-icon left small
                                      >mdi-cash-multiple</v-icon
                                    >
                                    Parcelas
                                  </v-tab>
                                  <v-tab>
                                    <v-icon left small>mdi-history</v-icon>
                                    Interações
                                  </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="activeTab">
                                  <v-tab-item>
                                    <!-- Parcelas -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.parcelas?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-cash-remove</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma parcela em aberta encontrada
                                        </div>
                                      </div>

                                      <v-data-table
                                        v-else
                                        :headers="[]"
                                        :items="contrato.parcelas"
                                        hide-default-header
                                        :items-per-page="5"
                                        class="elevation-0 mt-2"
                                        :footer-props="{
                                          'items-per-page-options': [5],
                                          'show-current-page': true,
                                          'show-first-last-page': true,
                                        }"
                                      >
                                        <template
                                          v-slot:item="{ item: parcela }"
                                        >
                                          <tr>
                                            <td>
                                              <div class="py-2 border-bottom">
                                                <div
                                                  class="caption d-flex justify-space-between"
                                                >
                                                  <div class="subtitle-2">
                                                    {{
                                                      formatDateBR(
                                                        parcela.vencimento,
                                                      )
                                                    }}
                                                  </div>
                                                  <v-chip
                                                    small
                                                    :color="
                                                      getVencimentoColor(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      )
                                                    "
                                                    :text-color="
                                                      getVencimentoColor(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      ) === 'error'
                                                        ? 'white'
                                                        : ''
                                                    "
                                                  >
                                                    {{
                                                      getVencimentoStatus(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      )
                                                    }}
                                                  </v-chip>
                                                </div>
                                                <div
                                                  class="caption d-flex justify-space-between align-center mt-2"
                                                >
                                                  <div
                                                    class="d-flex align-center"
                                                  >
                                                    <div
                                                      class="caption"
                                                      style="width: 9rem"
                                                    >
                                                      Ref:
                                                      {{
                                                        parcela.identificacao
                                                      }}
                                                    </div>
                                                    <v-btn
                                                      v-if="parcela.idDocumento"
                                                      x-small
                                                      color="primary"
                                                      class="ml-2"
                                                      @click="
                                                        abrirDialogSelecaoFormaPagamento(
                                                          parcela.idDocumento,
                                                        )
                                                      "
                                                      :loading="
                                                        loadingFormaPagamento ===
                                                        parcela.idDocumento
                                                      "
                                                      title="Pagar"
                                                      :disabled="
                                                        !isCurrentUserAttendant &&
                                                        !isCurrentUserParticipant
                                                      "
                                                    >
                                                      <v-icon left small
                                                        >mdi-credit-card</v-icon
                                                      >
                                                      Pagar
                                                    </v-btn>
                                                  </div>

                                                  <div class="subtitle-2">
                                                    R$
                                                    {{
                                                      parcela.valor
                                                        ?.toFixed(2)
                                                        .replace(".", ",")
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </div>
                                  </v-tab-item>

                                  <v-tab-item>
                                    <!-- Interações -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.interacoes?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-message-text-outline</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma interação encontrada
                                        </div>
                                      </div>

                                      <v-data-table
                                        v-else
                                        :headers="[]"
                                        :items="contrato.interacoes"
                                        hide-default-header
                                        :items-per-page="5"
                                        class="elevation-0 mt-2"
                                        :footer-props="{
                                          'items-per-page-options': [5],
                                          'show-current-page': true,
                                          'show-first-last-page': true,
                                        }"
                                      >
                                        <template v-slot:item="{ item: i }">
                                          <tr>
                                            <td>
                                              <div class="py-2 border-bottom">
                                                <div class="caption">
                                                  {{ i.assunto }}
                                                </div>

                                                <div class="caption">
                                                  {{ i.descricao }}
                                                </div>
                                                <div
                                                  class="caption d-flex justify-space-between mt-2"
                                                >
                                                  <v-chip small>{{
                                                    i.contrato
                                                  }}</v-chip>
                                                  {{
                                                    formatDateBR(
                                                      i.dataInteracao,
                                                    )
                                                  }}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </div>
                                  </v-tab-item>
                                  <v-tab-item>
                                    <!-- Interações -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.protocols?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-message-text-outline</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma interação encontrada
                                        </div>
                                      </div>
                                    </div>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <v-divider class="my-3"></v-divider>
                  <v-expansion-panels>
                    <v-expansion-panel class="expansion-panel">
                      <v-expansion-panel-header>
                        <div class="pt-0 subtitle-1 font-weight-medium">
                          Protocolos ({{
                            clientInfo.protocolos
                              ? clientInfo.protocolos.length
                              : 0
                          }})
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content expand>
                        <div class="pt-0">
                          <v-data-table
                            :headers="[]"
                            :items="clientInfo.protocolos"
                            hide-default-header
                            :items-per-page="5"
                            class="elevation-0 mt-2"
                            :footer-props="{
                              'items-per-page-options': [5],
                              'show-current-page': true,
                              'show-first-last-page': true,
                            }"
                          >
                            <template v-slot:item="{ item: i }">
                              <tr>
                                <td>
                                  <div class="py-2 border-bottom">
                                    <div
                                      class="d-flex justify-space-between align-center"
                                    >
                                      <!-- Texto -->
                                      <div>
                                        <div class="text-body-2">
                                          Protocolo: {{ i.protocolNumber }}
                                        </div>

                                        <div class="caption">
                                          Responsável: {{ i.userInsert }}
                                        </div>
                                      </div>

                                      <!-- Botão -->
                                      <v-btn
                                        small
                                        text
                                        color="primary"
                                        @click="abrirProtocolo(i)"
                                      >
                                        <v-icon>mdi-eye</v-icon>
                                      </v-btn>
                                    </div>

                                    <div
                                      class="caption d-flex justify-space-between mt-2"
                                    >
                                      <v-chip
                                        small
                                        :color="
                                          i.status === 'closed'
                                            ? 'green'
                                            : 'warning'
                                        "
                                      >
                                        {{
                                          i.status === "closed"
                                            ? "Concluído"
                                            : "Aberto"
                                        }}
                                      </v-chip>

                                      {{ formatDate(i.dataCreate) }}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <!-- Protocolos -->
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <!-- Diálogo para exibir informações do cliente -->
    <v-dialog v-model="showClientInfoDialog" max-width="800" scrollable>
      <v-card class="pt-0">
        <!-- Cabeçalho do card -->
        <v-card-title class="headline primary white--text">
          Detalhes do Cliente
        </v-card-title>

        <!-- Conteúdo principal do card -->
        <v-card-text>
          <!-- Loading -->
          <div v-if="loadingClientInfoDialog" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Carregando informações do cliente...</div>
          </div>

          <!-- Erro -->
          <div v-else-if="clientInfoDialogError" class="text-center py-5 pt-12">
            <v-alert type="error" outlined>
              {{ clientInfoDialogError }}
            </v-alert>
            <v-btn
              color="primary"
              @click="consultarClientePorTelefone(phoneNumber)"
              class="mt-3"
            >
              <v-icon left>mdi-refresh</v-icon>
              Tentar novamente
            </v-btn>
          </div>

          <!-- Sem dados -->
          <div v-else-if="!clientInfoDialog" class="text-center py-5">
            <v-alert type="info" outlined>
              Nenhuma informação disponível para este cliente.
            </v-alert>
          </div>

          <!-- Dados do cliente -->
          <div v-else class="mt-4">
            <!-- Tabela de resultados -->
            <div class="mb-4">
              <div class="d-flex align-center mb-2">
                <v-chip color="primary" small class="mr-2">
                  {{ clientsDialogCount }} clientes encontrados
                </v-chip>
                <div class="caption">Selecione um cliente para continuar</div>
              </div>

              <v-data-table
                :headers="clienteHeaders"
                :items="clientsDialog"
                :items-per-page="10"
                class="elevation-0"
                @click:row="selecionarEFecharDialog"
                :loading="loadingClientInfoDialog"
              >
                <template v-slot:item.nome="{ item }">
                  <div class="font-weight-medium">
                    {{ item.nome || "Nome não informado" }}
                  </div>
                </template>

                <template v-slot:item.cpf="{ item }">
                  {{ formatCpf(item.cpf) || "Não informado" }}
                </template>

                <template v-slot:item.telefone="{ item }">
                  {{ item.telefone || "Não informado" }}
                </template>

                <template v-slot:item.actions="{ item, index }">
                  <v-btn
                    x-small
                    color="primary"
                    @click.stop="selecionarEFecharDialog(item, index)"
                  >
                    <v-icon x-small left>mdi-check</v-icon>
                    Selecionar
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showClientInfoDialog = false" small>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar contato do cliente -->
    <v-dialog v-model="showEditClientContactDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Editar contato do cliente
        </v-card-title>

        <v-card-text>
          <v-form ref="editClientContactFormRef">
            <v-text-field
              label="ID do Cliente"
              :value="editClientContactForm.idCliente"
              outlined
              dense
              readonly
              disabled
              class="mb-4"
            ></v-text-field>

            <v-text-field
              label="Celular"
              v-model="editClientContactForm.celular"
              v-mask="'(##) #####-####'"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              label="Telefone"
              v-model="editClientContactForm.telefone"
              v-mask="'(##) ####-####'"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              label="E-mail"
              v-model="editClientContactForm.email"
              outlined
              dense
            ></v-text-field>

            <!-- Endereço apenas visual (não editável) -->
            <v-textarea
              label="Endereço"
              :value="editClientContactForm.endereco"
              outlined
              dense
              readonly
              disabled
              auto-grow
              rows="2"
              class="mt-2"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showEditClientContactDialog = false"
            :disabled="updatingClientContact"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="atualizarContatoCliente"
            :loading="updatingClientContact"
            :disabled="updatingClientContact"
          >
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar interação do cliente -->
    <v-dialog v-model="showAddClientInteractionDialog" max-width="500">
      <v-card>
        <v-card-title class="headline"> Adicionar interação </v-card-title>

        <v-card-text>
          <v-form ref="addClientInteractionFormRef">
            <v-select
              label="Tipo de interação"
              v-model="addClientInteractionForm.tipo"
              :items="interactionTypes"
              item-text="label"
              item-value="value"
              outlined
              dense
            ></v-select>

            <v-select
              label="Contrato"
              v-model="addClientInteractionForm.contratoId"
              :items="availableClientContracts"
              item-text="label"
              item-value="id"
              outlined
              dense
              class="mt-3"
            ></v-select>

            <v-textarea
              label="Descrição da interação"
              v-model="addClientInteractionForm.descricao"
              outlined
              dense
              auto-grow
              rows="4"
              counter="255"
              maxlength="255"
              class="mt-3"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showAddClientInteractionDialog = false"
            :disabled="savingClientInteraction"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="salvarInteracaoCliente"
            :loading="savingClientInteraction"
            :disabled="savingClientInteraction"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de resultado da atualização de contato -->
    <v-dialog v-model="showClientUpdateResultDialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmado </v-card-title>
        <v-card-text>
          {{ clientUpdateResultMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showClientUpdateResultDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de resultado da interação do cliente -->
    <v-dialog v-model="showClientInteractionResultDialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmado </v-card-title>
        <v-card-text>
          {{ clientInteractionResultMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showClientInteractionResultDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showDialogFinalizarProtocolosCampanha"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Finalizar Campanha
        </v-card-title>

        <v-card-text class="pa-4">
          <!-- Campo da campanha -->
          <v-text-field
            v-model="campanhaName"
            label="Nome da campanha"
            outlined
            dense
            required
            :disabled="loadingFinalizarProtocolosCampanha"
          />
          <!-- Loading -->
          <v-row
            v-if="loadingFinalizarProtocolosCampanha"
            class="mt-4 mb-4"
            align="center"
            justify="center"
          >
            <v-progress-circular indeterminate color="primary" />
            <span class="ml-3">Finalizando campanha...</span>
          </v-row>

          <!-- Resultado -->
          <v-alert
            v-if="resultadoFinalizacao"
            :type="!resultadoFinalizacao.error ? 'success' : 'error'"
            outlined
            class="mt-4"
          >
            {{ resultadoFinalizacao.message }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="showDialogFinalizarProtocolosCampanha = false"
            :disabled="loadingFinalizarProtocolosCampanha"
          >
            Fechar
          </v-btn>

          <v-btn
            color="primary"
            :disabled="
              !campanhaName ||
              loadingFinalizarProtocolosCampanha ||
              resultadoFinalizacao
            "
            @click="confirmarFinalizacaoCampanha"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Novo Atendimento -->
    <v-dialog
      v-model="showNewAttendanceDialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Novo Atendimento
        </v-card-title>
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- 1. Template selecionado -->
            <div class="mb-4">
              <!-- Select de Templates -->
              <v-select
                v-model="selectedTemplateId"
                :items="activeTemplates"
                item-text="name"
                item-value="_id"
                label="Selecione um template"
                :loading="loadingTemplates"
                :disabled="loadingTemplates"
                @change="onTemplateSelectChange"
                clearable
                outlined
                hide-details
                dense
              ></v-select>

              <v-alert
                v-if="!selectedTemplate"
                type="info"
                dense
                class="mt-2 mb-3 py-1"
              >
                Selecione um template para iniciar uma conversa
              </v-alert>

              <!-- Exibição do template (apenas quando selecionado) -->
              <v-card v-if="selectedTemplate" flat outlined class="mt-2">
                <v-card-subtitle class="caption">
                  Template: {{ selectedTemplate.name }}
                </v-card-subtitle>
                <v-card-text class="pa-2">
                  <div class="caption">
                    {{ selectedTemplate.content }}
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <!-- 2. Busca do cliente (visível apenas quando não há cliente selecionado) -->
            <div v-if="!clienteSelecionado" class="mb-4">
              <div class="d-flex align-center mb-2">
                <v-select
                  v-model="tipoBusca"
                  :items="tiposBusca"
                  item-text="text"
                  item-value="value"
                  label="Tipo de busca"
                  outlined
                  dense
                  hide-details
                  class="mr-2"
                  style="max-width: 150px"
                ></v-select>
                <v-text-field
                  v-model="valorBusca"
                  :label="labelBusca"
                  outlined
                  dense
                  hide-details
                  class="flex-grow-1"
                >
                  <template v-slot:append>
                    <v-btn
                      text
                      color="primary"
                      @click="consultarFichaCliente(valorBusca, tipoBusca)"
                      :loading="loadingClientInfoDialog"
                      :disabled="
                        !valorBusca ||
                        (tipoBusca === 'telefone' && valorBusca.length < 8)
                      "
                      title="Buscar cliente"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </div>
            </div>

            <!-- 5. Exibição do cliente selecionado -->
            <div
              v-if="clienteSelecionado"
              class="mb-4 pa-3 grey lighten-4 rounded"
            >
              <div class="d-flex justify-space-between align-center mb-2">
                <div class="subtitle-1 font-weight-bold">
                  Cliente selecionado
                </div>
                <v-btn
                  x-small
                  text
                  color="primary"
                  @click="trocarCliente"
                  title="Trocar cliente"
                >
                  <v-icon x-small left>mdi-account-switch</v-icon>
                  Trocar
                </v-btn>
              </div>

              <div class="d-flex align-center">
                <v-avatar size="36" color="primary" class="white--text mr-3">
                  {{
                    clienteSelecionado.nome
                      ? clienteSelecionado.nome.charAt(0).toUpperCase()
                      : "?"
                  }}
                </v-avatar>
                <div>
                  <div class="subtitle-2 font-weight-medium">
                    {{ clienteSelecionado.nome || "Nome não informado" }}
                  </div>
                  <div class="caption">
                    <span class="font-weight-medium">CPF:</span>
                    {{ formatCpf(clienteSelecionado.cpf) || "Não informado" }}
                  </div>
                </div>
              </div>

              <!-- Lista de contratos -->
              <div
                v-if="
                  clienteSelecionado.contratos &&
                  clienteSelecionado.contratos.length > 0
                "
                class="mt-4"
              >
                <div class="subtitle-1 font-weight-medium mb-2">
                  Contratos ({{ clienteSelecionado.contratos.length }})
                </div>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="contrato in clienteSelecionado.contratos"
                    :key="contrato.id"
                    class="expansion-panel"
                  >
                    <v-expansion-panel-header>
                      <div>
                        <div class="font-weight-medium">
                          {{ contrato.tipo }}
                        </div>
                        <div class="caption">
                          <v-chip
                            x-small
                            :color="
                              contrato.status === 'Ativo' ||
                              contrato.status === 'ATIVO'
                                ? 'success'
                                : 'red'
                            "
                            class="mr-1"
                          >
                            {{ contrato.status }}
                          </v-chip>
                          Ref: {{ contrato.referencia }}
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content expand>
                      <v-divider></v-divider>

                      <!-- Detalhes simples -->
                      <div class="py-3">
                        <div>
                          <strong>Empresa:</strong> {{ contrato.empresa }}
                        </div>
                        <div>
                          <strong>Data:</strong>
                          {{ formatDate(contrato.dataContrato) }}
                        </div>

                        <!-- Informações de LTV -->
                        <div v-if="contrato.ltv" class="mt-4">
                          <v-divider class="my-1"></v-divider>
                          <div class="subtitle-2 mb-1">Informações de LTV</div>

                          <v-row dense class="py-2">
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Severidade:</strong>
                                {{ contrato.ltv.severidade }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>LTV:</strong>
                                {{ contrato.ltv.ltv?.toFixed(4) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Débito Cliente:</strong> R$
                                {{ contrato.ltv.debitoCliente?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>% Aplicado:</strong>
                                {{ contrato.ltv.percentualAplicado }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Desconto:</strong> R$
                                {{ contrato.ltv.desconto?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Valor Final:</strong> R$
                                {{ contrato.ltv.valorFinal?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <div class="caption">
                                <strong>Oferta:</strong>
                                {{ contrato.ltv.oferta }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <v-divider></v-divider>

                      <!-- Parcelas -->
                      <!-- Sistema de abas para parcelas e interações -->
                      <v-tabs
                        v-model="activeTab"
                        background-color="transparent"
                        color="primary"
                        grow
                        class="mt-3"
                      >
                        <v-tab>
                          <v-icon left small>mdi-cash-multiple</v-icon>
                          Parcelas
                        </v-tab>
                        <v-tab>
                          <v-icon left small>mdi-history</v-icon>
                          Interações
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="activeTab">
                        <v-tab-item>
                          <!-- Parcelas -->
                          <div class="pa-0 pt-4">
                            <div
                              v-if="!contrato.parcelas?.length"
                              class="caption text-center pa-4"
                            >
                              <v-icon large color="grey lighten-1"
                                >mdi-cash-remove</v-icon
                              >
                              <div class="mt-2">
                                Nenhuma parcela em aberta encontrada
                              </div>
                            </div>

                            <v-data-table
                              v-else
                              :headers="[]"
                              :items="contrato.parcelas"
                              hide-default-header
                              :items-per-page="5"
                              class="elevation-0 mt-2"
                              :footer-props="{
                                'items-per-page-options': [5, 10, 15],
                                'show-current-page': true,
                                'show-first-last-page': true,
                                'items-per-page-text': 'Itens por página:',
                              }"
                            >
                              <template v-slot:item="{ item: parcela }">
                                <tr>
                                  <td>
                                    <div class="py-2 border-bottom">
                                      <div
                                        class="caption d-flex justify-space-between"
                                      >
                                        <div class="subtitle-2">
                                          {{ formatDateBR(parcela.vencimento) }}
                                        </div>
                                        <v-chip
                                          small
                                          :color="
                                            getVencimentoColor(
                                              parcela.vencimento,
                                              parcela.status,
                                            )
                                          "
                                          :text-color="
                                            getVencimentoColor(
                                              parcela.vencimento,
                                              parcela.status,
                                            ) === 'error'
                                              ? 'white'
                                              : ''
                                          "
                                        >
                                          {{
                                            getVencimentoStatus(
                                              parcela.vencimento,
                                              parcela.status,
                                            )
                                          }}
                                        </v-chip>
                                      </div>
                                      <div
                                        class="caption d-flex justify-space-between align-center mt-2"
                                      >
                                        <div class="d-flex align-center">
                                          <div class="caption">
                                            Identificação:
                                            {{ parcela.identificacao }}
                                          </div>
                                        </div>

                                        <div class="subtitle-2">
                                          R$
                                          {{
                                            parcela.valor
                                              ? parcela.valor
                                                  .toFixed(2)
                                                  .replace(".", ",")
                                              : "0,00"
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </div>
                        </v-tab-item>

                        <v-tab-item>
                          <!-- Interações -->
                          <div class="pa-0 pt-4">
                            <div
                              v-if="!contrato.interacoes?.length"
                              class="caption text-center pa-4"
                            >
                              <v-icon large color="grey lighten-1"
                                >mdi-message-text-outline</v-icon
                              >
                              <div class="mt-2">
                                Nenhuma interação encontrada
                              </div>
                            </div>

                            <v-data-table
                              v-else
                              :headers="[]"
                              :items="contrato.interacoes"
                              hide-default-header
                              :items-per-page="5"
                              class="elevation-0 mt-2"
                              :footer-props="{
                                'items-per-page-options': [5, 10, 15],
                                'show-current-page': true,
                                'show-first-last-page': true,
                                'items-per-page-text': 'Itens por página:',
                              }"
                            >
                              <template v-slot:item="{ item: i }">
                                <tr>
                                  <td>
                                    <div class="py-2 border-bottom">
                                      <div class="caption">
                                        {{ i.assunto }}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </div>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>

            <!-- 3. Campo de telefone (readonly quando cliente selecionado) -->
            <div class="mb-4">
              <v-text-field
                v-model="phoneNumber"
                label="Número de telefone"
                prefix="+55"
                required
                outlined
                dense
                hide-details
                readonly
                :disabled="clienteSelecionado !== null"
                @blur="autoPreencherParams"
              ></v-text-field>
            </div>

            <!-- 4. Parâmetros do template -->
            <template v-if="selectedTemplate">
              <div
                v-for="(param, index) in extractTemplateParams(
                  selectedTemplate.content,
                )"
                :key="index"
                class="mb-2"
              >
                <v-text-field
                  v-model="templateParams[index]"
                  :label="
                    templateParamLabels[index] || `Parâmetro ${index + 1}`
                  "
                  required
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </div>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn
            text
            color="info"
            @click="abrirDialogInteracoes"
            :loading="loadingInteracoes"
          >
            <v-icon left small>mdi-history</v-icon>
            Minha Listagem
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNewAttendanceDialog"> Cancelar </v-btn>
          <v-btn
            color="primary"
            :loading="sendingMessage || checkingContact"
            :disabled="
              !valid ||
              sendingMessage ||
              checkingContact ||
              !phoneNumber ||
              !selectedTemplate ||
              !allParametersFilled
            "
            @click="checkContactAndSend"
          >
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de arquivo enviado -->
    <v-dialog v-model="showFileUrlDialog" max-width="500">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-check-circle</v-icon>
          Envios de Arquivos
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="success" outlined class="mb-0">
            O arquivo foi enviado com sucesso.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeFileUrlDialog"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de gravação de áudio -->
    <v-dialog v-model="dialogAudio" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <span>{{
            isRecording ? "Gravando áudio..." : "Gravar mensagem de áudio"
          }}</span>
        </v-card-title>

        <v-card-text class="pa-4 text-center">
          <!-- Solicitar permissão -->
          <div v-if="permissaoMicrofone === null" class="my-4">
            <v-icon size="64" color="#4caf50" class="mb-4"
              >mdi-microphone</v-icon
            >
            <div class="title mb-2">Permissão para usar o microfone</div>
            <div class="subtitle-1 grey--text mb-4">
              Para gravar áudio, precisamos da sua permissão para acessar o
              microfone.
            </div>
            <v-btn
              color="#4caf50"
              @click="solicitarPermissaoMicrofone"
              :loading="solicitandoPermissao"
            >
              <v-icon left>mdi-microphone</v-icon>
              Permitir acesso
            </v-btn>
          </div>

          <!-- Permissão negada -->
          <div v-else-if="permissaoMicrofone === false" class="my-4">
            <v-icon size="64" color="red" class="mb-4"
              >mdi-microphone-off</v-icon
            >
            <div class="title mb-2">Permissão negada</div>
            <div class="subtitle-1 grey--text mb-4">
              Você não permitiu o acesso ao microfone. Para gravar áudio, é
              necessário permitir o acesso nas configurações do seu navegador.
            </div>
          </div>

          <!-- Gravador de áudio -->
          <div v-else class="audio-recorder-container">
            <div
              class="audio-visualizer mb-4"
              :class="{ 'is-recording': isRecording }"
            >
              <div class="time-counter">
                {{ formatAudioTime(audioDuration) }}
              </div>
              <div class="wave-container">
                <div class="wave" v-for="n in 5" :key="n"></div>
              </div>
            </div>

            <!-- Botões de controle -->
            <div class="audio-controls">
              <!-- Botão de gravação -->
              <v-btn
                v-if="!isRecording && !audioBlob"
                fab
                color="#4caf50"
                @click="iniciarGravacao"
                class="mx-2"
              >
                <v-icon>mdi-microphone</v-icon>
              </v-btn>

              <!-- Botão de parar -->
              <v-btn
                v-if="isRecording"
                fab
                color="red"
                @click="pararGravacao"
                class="mx-2"
              >
                <v-icon>mdi-stop</v-icon>
              </v-btn>

              <!-- Player de áudio (após gravar) -->
              <audio
                v-if="audioURL && !isRecording"
                controls
                :src="audioURL"
                class="audio-preview-player mb-3"
              ></audio>

              <!-- Botões após gravar -->
              <div
                v-if="audioBlob && !isRecording"
                class="d-flex justify-center mt-3"
              >
                <v-btn
                  text
                  color="error"
                  @click="descartarAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-delete</v-icon>
                  Descartar
                </v-btn>

                <v-btn
                  color="#4caf50"
                  @click="enviarAudio"
                  :loading="enviandoAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-send</v-icon>
                  Enviar
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="fecharDialogAudio"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de anexo de arquivo -->
    <v-dialog v-model="showFileAttachmentDialog" max-width="500">
      <v-card>
        <v-card-title class="headline primary white--text">
          Anexar arquivo
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-if="fileError" type="error" outlined class="mb-4">
            {{ fileError }}
          </v-alert>

          <v-file-input
            v-model="selectedFile"
            label="Selecione um arquivo"
            outlined
            dense
            show-size
            counter
            accept="image/*, video/*, audio/*, application/pdf"
            :rules="[
              (v) => !!v || 'Selecione um arquivo',
              (v) =>
                !v || v.size < 10000000 || 'O arquivo deve ter menos de 10MB',
            ]"
            @change="handleFileChange"
          ></v-file-input>

          <div v-if="selectedFile" class="mt-4">
            <v-alert type="info" outlined>
              <strong>Nome:</strong> {{ selectedFileName }}<br />
              <strong>Tamanho:</strong> {{ formatFileSize(selectedFileSize) }}
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeFileAttachmentDialog"> Cancelar </v-btn>
          <v-btn
            color="primary"
            :loading="sendingFile"
            :disabled="
              !selectedFile || sendingFile || selectedFileSize > 10000000
            "
            @click="sendAttachedFile"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de erro de vinculação de atendimento -->
    <v-dialog v-model="showVinculacaoErrorDialog" max-width="500">
      <v-card>
        <v-card-title class="headline error white--text">
          Erro ao vincular atendimento
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="error" outlined>
            {{ vinculacaoErrorMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeVinculacaoErrorDialog">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Protocolo Existente -->
    <v-dialog v-model="showProtocolDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline warning">
          Protocolo Existente
        </v-card-title>
        <v-card-text>
          <p class="body-1 mb-3">Este contato já possui um protocolo aberto.</p>
          <v-divider class="my-3"></v-divider>
          <div v-if="contactInfo && contactInfo.data">
            <p>
              <strong>Telefone:</strong> {{ contactInfo.data.numeroTelefone }}
            </p>
            <p v-if="contactInfo.data.protocolNumber">
              <strong>Protocolo:</strong> {{ contactInfo.data.protocolNumber }}
            </p>
            <p v-if="contactInfo.data.dataCreate">
              <strong>Data de Abertura:</strong>
              {{ formatDate(contactInfo.data.dataCreate) }}
            </p>
            <p v-if="contactInfo.data.userInsert">
              <strong>Criado por:</strong> {{ contactInfo.data.userInsert }}
            </p>
            <p
              v-if="
                contactInfo.data.protocolosAbertos &&
                contactInfo.data.protocolosAbertos.length > 1
              "
            >
              <strong>Total de Protocolos Abertos:</strong>
              {{ contactInfo.data.protocolosAbertos.length }}
            </p>
          </div>
          <v-alert type="warning" outlined class="mt-3">
            Não é possível criar um novo protocolo enquanto houver um protocolo
            aberto para este contato.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeProtocolDialog"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Fechar Protocolo -->
    <v-dialog
      v-model="showCloseProtocolConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Confirmar fechamento de protocolo
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja fechar este protocolo?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelCloseProtocol">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" text @click="executeCloseProtocol">
            Fechar Protocolo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Remover Participante ou Sair do Atendimento -->
    <v-dialog
      v-model="showRemoveParticipantConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline"
          :class="
            isCurrentUserAttendant
              ? 'amber darken-2 white--text'
              : 'warning white--text'
          "
        >
          <v-icon color="white" class="mr-2">{{
            isCurrentUserAttendant ? "mdi-account-minus" : "mdi-exit-to-app"
          }}</v-icon>
          {{
            isCurrentUserAttendant
              ? "Confirmar remoção de participante"
              : "Confirmar saída do atendimento"
          }}
        </v-card-title>
        <v-card-text class="pt-4">
          {{
            isCurrentUserAttendant
              ? "Tem certeza que deseja remover o participante deste atendimento?"
              : "Tem certeza que deseja sair deste atendimento?"
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelRemoveParticipant">
            Cancelar
          </v-btn>
          <v-btn
            :color="isCurrentUserAttendant ? 'amber darken-3' : 'warning'"
            text
            @click="executeRemoveParticipant(isCurrentUserAttendant)"
          >
            {{
              isCurrentUserAttendant
                ? "Remover Participante"
                : "Sair do Atendimento"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Sair do Atendimento -->
    <v-dialog
      v-model="showExitAttendanceConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline warning white--text">
          Confirmar saída do atendimento
        </v-card-title>
        <v-card-text class="pt-4">
          Tem certeza que deseja sair deste atendimento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelExitAttendance">
            Cancelar
          </v-btn>
          <v-btn color="warning" text @click="executeExitAttendance()">
            Sair do Atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para transferência de atendimento -->
    <v-dialog
      v-model="showTransferDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Transferir Atendimento
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para transferir o atendimento do protocolo
            <strong>{{ currentProtocol }}</strong>
          </v-alert>

          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>

          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showTransferDialog = false;
              selectedColaboradores = [];
              transferringAttendance = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="executarTransferencia"
            :disabled="!selectedColaboradores.length || transferringAttendance"
            :loading="transferringAttendance"
          >
            <v-icon left small>mdi-check</v-icon>
            Transferir Atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para transferência de fila -->
    <v-dialog
      v-model="showTransferFilaDialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline info white--text">
          <v-icon left color="white">mdi-swap-horizontal</v-icon>
          Transferir Fila
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-4">
            Selecione a fila de destino para transferir o protocolo
            <strong>{{ currentProtocol }}</strong>
          </v-alert>

          <div class="mb-3">
            <div class="text--secondary mb-2">Fila Atual:</div>
            <v-chip color="primary" outlined>
              <v-icon left small>mdi-folder</v-icon>
              {{ filaAtualProtocolo || "Não definida" }}
            </v-chip>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="mb-3">
            <div class="text--secondary mb-2">Selecione a nova fila:</div>
          </div>

          <v-radio-group v-model="filaDestinoSelecionada" class="mt-0">
            <v-radio
              v-for="fila in filasDisponiveis"
              :key="fila.id"
              :label="fila.nomeFila"
              :value="fila.id"
              color="primary"
            >
              <template v-slot:label>
                <div class="d-flex align-center">
                  <v-icon left small color="primary">mdi-folder-outline</v-icon>
                  <span style="color: black">{{ fila.nomeFila }}</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>

          <v-alert
            v-if="!filasDisponiveis.length"
            type="warning"
            outlined
            dense
            class="mt-3"
          >
            Nenhuma fila disponível para transferência.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="fecharDialogTransferenciaFila"
            :disabled="transferindoFila"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            @click="executarTransferenciaFila"
            :disabled="!filaDestinoSelecionada || transferindoFila"
            :loading="transferindoFila"
          >
            <v-icon left small>mdi-check</v-icon>
            Transferir Fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de pré-visualização de mídia -->
    <v-dialog v-model="mediaPreviewDialog" max-width="90vw" max-height="90vh">
      <v-card>
        <v-card-title class="headline primary white--text">
          Visualização de
          {{
            mediaPreviewType === "image"
              ? "Imagem"
              : mediaPreviewType === "video"
              ? "Vídeo"
              : mediaPreviewType === "audio"
              ? "Áudio"
              : "Arquivo"
          }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="mediaPreviewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4 text-center">
          <!-- Imagem -->
          <div v-if="mediaPreviewType === 'image'" class="text-center">
            <v-img
              :src="mediaPreviewUrl"
              max-height="80vh"
              contain
              class="rounded"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <!-- Vídeo -->
          <div v-else-if="mediaPreviewType === 'video'" class="text-center">
            <video
              controls
              autoplay
              class="rounded"
              style="max-width: 100%; max-height: 80vh"
            >
              <source :src="mediaPreviewUrl" />
              Seu navegador não suporta a reprodução de vídeos.
            </video>
          </div>

          <!-- Áudio -->
          <div v-else-if="mediaPreviewType === 'audio'" class="text-center">
            <audio controls autoplay class="w-100 mt-8">
              <source :src="mediaPreviewUrl" />
              Seu navegador não suporta a reprodução de áudios.
            </audio>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :href="mediaPreviewUrl"
            target="_blank"
            download
          >
            <v-icon left>mdi-download</v-icon>
            Baixar
          </v-btn>
          <v-btn color="grey darken-1" text @click="mediaPreviewDialog = false">
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar participante -->
    <v-dialog
      v-model="showParticipantDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline success white--text">
          Adicionar Participante
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para adicionar como participante no
            protocolo
            <strong>{{ currentProtocol }}</strong>
          </v-alert>

          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>

          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showParticipantDialog = false;
              selectedColaboradores = [];
              addingParticipant = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="adicionarParticipante"
            :disabled="!selectedColaboradores.length || addingParticipant"
            :loading="addingParticipant"
          >
            <v-icon left small>mdi-check</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Seleção de Forma de Pagamento -->
    <v-dialog
      v-model="showSelecaoFormaPagamentoDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-overlay :value="loadingFormaPagamento !== null" absolute>
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
          <div class="mt-4 white--text">Processando...</div>
        </v-overlay>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-credit-card</v-icon>
          Selecionar Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-4">Escolha a forma de pagamento desejada:</p>
          <v-list>
            <v-list-item
              class="mb-2"
              :disabled="loadingFormaPagamento !== null"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
              @click="selecionarFormaPagamento('PDF')"
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-file-document</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PDF Boleto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Pix')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-qrcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Pix</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Link de Pagamento')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-link</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Link de Pagamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Código de Barras')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-barcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Código de Barras</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="closeSelecaoFormaPagamentoDialog"
            :disabled="loadingFormaPagamento !== null"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Forma de Pagamento -->
    <v-dialog
      v-model="showFormaPagamentoDialog"
      max-width="800"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- Mensagem de erro -->
          <p v-if="formaPagamentoResponse" class="body-1">
            {{ formaPagamentoResponse }}
          </p>

          <!-- Link da forma de pagamento -->
          <div v-if="formaPagamentoLink">
            <p class="body-2 mb-2">Link gerado:</p>
            <v-text-field
              :value="formaPagamentoLink"
              readonly
              outlined
              dense
              class="mb-3"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Botões quando houver link -->
          <template v-if="formaPagamentoLink">
            <v-btn
              color="success"
              @click="enviarMensagemFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
            <v-btn color="info" @click="copiarLinkFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
          </template>
          <!-- Botão copiar quando houver apenas mensagem (exceto mensagem de erro de forma não habilitada) -->
          <template
            v-else-if="
              formaPagamentoResponse &&
              formaPagamentoResponse !==
                'Esta forma de pagamento não está habilitada para este documento.'
            "
          >
            <v-btn color="info" @click="copiarTextoFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
            <v-btn
              color="success"
              @click="enviarMensagemTextoFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
          </template>
          <v-btn color="primary" @click="closeFormaPagamentoDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Boleto PDF -->
    <v-dialog
      v-model="showBoletoPdfDialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-file-pdf-box</v-icon>
          Boleto Gerado
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="boletoPdfUrl" style="height: 600px">
            <iframe
              :src="boletoPdfUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 1px solid #ddd; border-radius: 4px"
            ></iframe>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeBoletoPdfDialog" outlined>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="enviarBoletoParaCliente"
            :loading="sendingBoleto"
            class="mr-2"
          >
            <v-icon left small>mdi-send</v-icon>
            Enviar para Cliente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Arquivos Enviados -->
    <v-dialog
      v-model="showArquivosDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Arquivos Enviados
        </v-card-title>

        <v-card-text class="pt-4">
          <v-data-table
            :headers="arquivosHeaders"
            :items="arquivosProtocolo"
            :loading="loadingArquivos"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingArquivos
                ? 'Carregando arquivos...'
                : 'Nenhum arquivo encontrado'
            "
          >
            <template v-slot:item.info="{ item }">
              <div class="d-flex flex-column">
                <div class="font-weight-medium">
                  {{ item.tipoValor }}
                  <v-chip
                    x-small
                    color="primary"
                    text-color="white"
                    v-if="item.valor && item.valor != ''"
                  >
                    {{ item.valor }}
                  </v-chip>
                </div>

                <div class="caption grey--text">
                  <v-icon x-small class="mr-1">mdi-account</v-icon>
                  {{ item.userInsert }}
                </div>

                <div class="caption grey--text">
                  <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                  {{ formatDate(item.dataCreate) }}
                </div>

                <div
                  class="caption text-truncate"
                  style="max-width: 280px"
                  :title="item.url"
                >
                  <v-icon x-small class="mr-1">mdi-link</v-icon>
                  {{ item.url }}
                </div>
              </div>
            </template>

            <!-- Coluna de ações -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                flat
                color="info"
                @click="copiarUrl(item.url)"
                title="Copiar URL"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showArquivosDialog = false">
            <v-icon left small>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Minhas Interações -->
    <v-dialog
      v-model="showInteracoesDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline info white--text">
          Minhas Interações
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- Filtros -->
          <v-row dense>
            <v-col cols="12" sm="5">
              <span>Data Inicial</span>
              <v-menu
                v-model="menuDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="filtroDataInicioFormatada"
                    label="Data Inicial"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="filtroDataInicio"
                  @input="menuDataInicio = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="5">
              <span>Data Final</span>
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="filtroDataFimFormatada"
                    label="Data Final"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="filtroDataFim"
                  @input="menuDataFim = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center">
              <v-btn
                color="primary"
                @click="buscarInteracoes"
                :loading="loadingInteracoes"
                class="mt-1"
                small
              >
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <!-- Tabela de Interações -->
          <v-data-table
            :headers="interacoesHeaders"
            :items="interacoes"
            :loading="loadingInteracoes"
            :search="searchInteracoes"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 mt-4"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchInteracoes"
                label="Buscar"
                prepend-icon="mdi-magnify"
                class="mx-4 mt-4"
                dense
                outlined
                hide-details
                clearable
              ></v-text-field>
            </template>
            <template v-slot:item.dtInteracao="{ item }">
              {{ formatDateBR(item.dtInteracao) }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                small
                label
                text-color="white"
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                x-small
                color="primary"
                @click="selecionarTelefone(item.telefone, item)"
                title="Selecionar este telefone"
              >
                <v-icon x-small left>mdi-check</v-icon>
                Selecionar
              </v-btn>

              <v-btn
                color="info"
                class="ml-2"
                x-small
                :disabled="!item.telefone || item.telefone.length < 8"
                @click="consultarFichaCliente(item.telefone, 'telefone')"
                :loading="loadingClientInfoDialog"
                title="Consultar ficha do cliente"
              >
                <v-icon x-small left>mdi-account-search</v-icon>
                DETALHES
              </v-btn>
            </template>
            <template v-slot:no-data>
              {{
                loadingInteracoes
                  ? "Carregando interações..."
                  : "Nenhuma interação encontrada"
              }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeInteracoesDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Mensagens do Protocolo -->
    <v-dialog v-model="showProtocolMessagesDialog" max-width="800" scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          Mensagens do Protocolo
          {{ protocolMessagesData ? protocolMessagesData.protocolNumber : "" }}
        </v-card-title>

        <v-card-text class="pt-4" style="height: 500px">
          <!-- Loading -->
          <div v-if="protocolMessagesLoading" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Carregando mensagens...</div>
          </div>

          <!-- Sem mensagens -->
          <div
            v-else-if="selectedProtocolMessages.length === 0"
            class="text-center py-5"
          >
            <v-alert type="info" outlined>
              Nenhuma mensagem encontrada para este protocolo.
            </v-alert>
          </div>

          <!-- Mensagens -->
          <div v-else class="chat-container">
            <!-- Mensagens do protocolo -->
            <div
              v-for="message in selectedProtocolMessages"
              :key="message._id"
              :class="[
                'message-bubble mb-2 pa-2',
                message.message_type === 'note'
                  ? 'note-message'
                  : message.direction === 'outgoing'
                  ? 'outgoing-message'
                  : 'incoming-message',
              ]"
            >
              <div v-if="message.message_type === 'error'" class="error--text">
                <v-alert type="error" dense text>
                  {{ stripHtml(message.message) }}
                </v-alert>
              </div>
              <div v-else-if="message.message_type === 'note'">
                {{ stripHtml(message.message) }}
              </div>
              <div
                v-else-if="message.message_type === 'file'"
                class="file-message"
              >
                <!-- Imagem -->
                <div
                  v-if="isImage(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <v-img
                    :src="message.fileUrl || message.message"
                    max-height="300"
                    contain
                    class="rounded"
                    @click="
                      openMediaPreview(message.fileUrl || message.message)
                    "
                    style="cursor: pointer"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <!-- Áudio -->
                <div
                  v-else-if="isAudio(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <audio controls preload="metadata" style="max-width: 100%">
                    <source :src="message.fileUrl || message.message" />
                    Seu navegador não suporta a reprodução de áudios.
                  </audio>
                </div>

                <!-- Vídeo -->
                <div
                  v-else-if="isVideo(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <video
                    controls
                    preload="metadata"
                    class="rounded"
                    style="max-width: 100%; max-height: 300px"
                  >
                    <source :src="message.fileUrl || message.message" />
                    Seu navegador não suporta a reprodução de vídeos.
                  </video>
                </div>

                <!-- Outros arquivos (download) -->
                <div v-else class="text-center media-container">
                  <v-icon class="media-icon mb-2" color="primary"
                    >mdi-file-document-outline</v-icon
                  >
                  <v-btn
                    small
                    outlined
                    color="primary"
                    :href="message.fileUrl || message.message"
                    target="_blank"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Abrir arquivo
                  </v-btn>
                </div>
              </div>
              <div v-else>
                {{ message.message }}
              </div>
              <div class="caption text-right">
                {{ formatDate(message.createdAt) }}
                <template
                  v-if="message.direction === 'outgoing' && message.userInsert"
                >
                  <br />
                  <span class="font-italic"
                    >Enviado por: {{ message.userInsert }}</span
                  >
                </template>
              </div>
              <!-- Status de leitura (apenas para mensagens enviadas) -->
              <div
                v-if="
                  message.direction === 'outgoing' &&
                  message.ack !== undefined &&
                  message.ack !== null
                "
                class="caption text-right mt-1"
                :class="{
                  'success--text': message.isRead === true,
                  'info--text':
                    message.isDelivered === true && message.isRead !== true,
                  'grey--text': !message.isDelivered,
                  'error--text': message.readStatus === 'error',
                }"
              >
                <template v-if="message.isRead === true">
                  <v-icon x-small color="success"> mdi-check-all </v-icon>
                  <span class="ml-1">Lido</span>
                </template>
                <template v-else-if="message.isDelivered === true">
                  <v-icon x-small color="info"> mdi-check-all </v-icon>
                  <span class="ml-1">Entregue</span>
                </template>
                <template v-else-if="message.readStatus === 'error'">
                  <v-icon x-small color="error">mdi-alert-circle</v-icon>
                  <span class="ml-1">Erro ao enviar</span>
                </template>
                <template v-else>
                  <v-icon x-small color="grey"> mdi-check </v-icon>
                  <span class="ml-1">Enviada</span>
                </template>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeProtocolMessagesDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SonaxService from "@/services/sonax";
import UsuarioService from "@/services/usuario";
import FiltroEmpresa from "./components/FiltroEmpresaChat.vue";

// Carregamento do emoji-picker
let emojiPickerLoaded = false;

async function loadEmojiPicker() {
  if (!emojiPickerLoaded) {
    await import("emoji-picker-element");
    emojiPickerLoaded = true;
  }
}

export default {
  name: "Chat",

  components: {
    FiltroEmpresa,
  },

  data: () => ({
    // Filtro de Meus Tickets
    meusAtendimentos: false,
    // Modal de pré-visualização de mídia
    mediaPreviewDialog: false,
    mediaPreviewUrl: null,
    mediaPreviewType: null,
    // Protocol dialog
    showProtocolMessagesDialog: false,
    protocolMessagesData: null,
    protocolMessagesLoading: false,
    selectedProtocolMessages: [],
    // Authentication
    isAuthenticated: false,
    authError: null,

    // Filtro de Empresa
    showErrorEmpresa: false,
    showNoPhoneDialog: false,
    empresaSemTelefone: "", // Nome da empresa sem telefone para exibir no diálogo
    showFiltroEmpresa: true,
    selectedEmpresa: null,
    filas: [],
    selectedFilaId: null, // Fila selecionada para filtrar protocolos
    filaMenu: false, // Controle do menu de seleção de fila

    templateParamLabels: [],

    // Referência para o textarea
    textareaRef: null,

    // Emoji picker
    showEmojiPicker: false,

    // Anexo de arquivo
    showFileAttachmentDialog: false,
    showFileUrlDialog: false,
    fileUrl: "",
    selectedFile: null,
    selectedFileName: "",
    selectedFileSize: 0,
    sendingFile: false,
    fileError: null,

    // Gravação de áudio
    dialogAudio: false,
    audioRecorder: null,
    isRecording: false,
    audioBlob: null,
    audioURL: null,
    audioDuration: 0,
    audioTimer: null,
    enviandoAudio: false,
    permissaoMicrofone: null,
    solicitandoPermissao: false,
    audioMimeType: "audio/webm", // Armazena o mimeType usado

    // Templates
    loadingTemplates: false,
    templates: [], // Array de templates (não mais um objeto complexo)
    selectedTemplate: null,
    selectedTemplateId: null, // ID do template selecionado no select
    showTemplateContent: false, // Controla exibição do conteúdo do template

    // Message sending
    valid: true,
    phoneNumber: "",
    phoneRules: [
      (v) => !!v || "Número de telefone é obrigatório",
      (v) => /^\d{10,11}$/.test(v) || "Número de telefone inválido",
    ],
    templateParams: [],
    freeTextMessage: "",
    sendingMessage: false,

    // Message history
    currentProtocol: null,
    currentProtocolId: null, // ID do protocolo para fechar
    messages: [], // Mensagens atuais do protocolo
    historicalMessages: [], // Mensagens históricas de outros protocolos
    loadingMessages: false,
    closingProtocol: false,
    linkingAttendance: false, // Loading para vincular atendimento
    unlinkingAttendance: false, // Loading para desvincular atendimento
    messagePollingInterval: null, // Intervalo para consulta automática de mensagens
    protocolPollingInterval: null, // Intervalo para consulta automática de protocolos

    // Protocolos
    openProtocols: [],
    loadingProtocols: false,
    selectedProtocolData: null,
    showingHistoricalMessages: false, // Controla a exibição das mensagens históricas
    protocolSearch: "", // Campo de busca para filtrar protocolos
    protocolStatusFilter: "aberto", // Filtro de status: "open" ou "closed"
    statusFilterOptions: [
      {
        value: "aberto",
        label: "Aberto",
        icon: "mdi-lock-open",
        color: "success",
      },
      {
        value: "fechados",
        label: "Fechado",
        icon: "mdi-lock",
        color: "grey",
      },
    ],

    // Verificação de contato
    checkingContact: false,
    showProtocolDialog: false,
    contactInfo: null,

    // Diálogo de Fechar Protocolo
    showCloseProtocolConfirmDialog: false,

    // Diálogo de Remover Participante
    showRemoveParticipantConfirmDialog: false,

    // Diálogo de Sair do Atendimento
    showExitAttendanceConfirmDialog: false,

    // Diálogo de erro de vinculação de atendimento
    showVinculacaoErrorDialog: false,
    vinculacaoErrorMessage: "",

    // Diálogo de Novo Atendimento
    showNewAttendanceDialog: false,

    showDialogFinalizarProtocolosCampanha: false,
    campanhaName: "",
    loadingFinalizarProtocolosCampanha: false,
    resultadoFinalizacao: null,

    showingClientDetails: false, // Controla a exibição dos detalhes do cliente
    clients: [], // Lista de clientes retornados pela API
    selectedClientIndex: 0, // Índice do cliente selecionado na lista
    clientInfo: null, // Informações do cliente selecionado
    loadingClientInfo: false, // Controla o estado de carregamento das informações do cliente
    clientInfoError: null, // Armazena erros na busca de informações do cliente
    expandedContracts: [], // Controla quais contratos estão expandidos
    activeTab: 0, // Controla qual aba está ativa (0 = Parcelas, 1 = Interações)
    panel: 0,

    // Diálogo de informações do cliente (novo atendimento)
    showClientInfoDialog: false, // Controla a exibição do diálogo de informações do cliente
    clientsDialog: [], // Lista de clientes retornados pela API para o diálogo
    selectedClientDialogIndex: 0, // Índice do cliente selecionado na lista do diálogo
    clientInfoDialog: null, // Informações do cliente selecionado no diálogo
    loadingClientInfoDialog: false, // Controla o estado de carregamento das informações do cliente no diálogo
    clientInfoDialogError: null, // Armazena erros na busca de informações do cliente no diálogo

    // Busca de clientes
    tipoBusca: "telefone", // Tipo de busca selecionado (telefone, nome, cpf)
    valorBusca: "", // Valor para busca - sincronizado com phoneNumber quando tipoBusca === "telefone"
    clienteSelecionado: null, // Cliente atualmente selecionado
    tiposBusca: [
      { text: "Telefone", value: "telefone" },
      { text: "Nome", value: "nome" },
      { text: "CPF", value: "cpf" },
    ],

    // Headers para a tabela de clientes
    clienteHeaders: [
      { text: "ID", value: "idCliente", sortable: true },
      { text: "Nome", value: "nome", sortable: true },
      { text: "CPF", value: "cpf", sortable: true },
      { text: "Telefone", value: "telefone", sortable: true },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
    ],

    // Diálogo de edição de contato do cliente
    showEditClientContactDialog: false,
    updatingClientContact: false, // Loading do botão Atualizar no diálogo de contato
    clienteIvertxAtual: null, // Guarda o objeto completo retornado pela iVertex
    editClientContactForm: {
      idCliente: null,
      celular: "",
      telefone: "",
      email: "",
      endereco: "",
    },

    // Diálogo de resultado da atualização de contato do cliente
    showClientUpdateResultDialog: false,
    clientUpdateResultMessage: "",

    // Diálogo de resultado da interação do cliente
    showClientInteractionResultDialog: false,
    clientInteractionResultMessage: "",

    // Diálogo de adicionar interação do cliente
    showAddClientInteractionDialog: false,
    savingClientInteraction: false,
    addClientInteractionForm: {
      tipo: null,
      contratoId: null,
      descricao: "",
    },

    // Forma de pagamento
    loadingFormaPagamento: null, // ID do documento sendo processado
    showFormaPagamentoDialog: false, // Controla exibição do diálogo
    formaPagamentoResponse: null, // Resposta da API de forma de pagamento (mensagem ou link)
    formaPagamentoLink: null, // Link da forma de pagamento quando houver
    showSelecaoFormaPagamentoDialog: false, // Controla exibição do diálogo de seleção
    idDocumentoSelecionado: null, // ID do documento selecionado para gerar forma de pagamento
    showBoletoPdfDialog: false, // Controla exibição do diálogo de boleto PDF
    boletoPdfUrl: null, // URL do PDF do boleto
    sendingBoleto: false, // Controla estado de envio do boleto

    // Minhas Interações
    showInteracoesDialog: false, // Controla exibição do diálogo de interações
    loadingInteracoes: false, // Controla o estado de carregamento das interações

    // Arquivos Enviados
    showArquivosDialog: false, // Controla exibição do diálogo de arquivos enviados
    loadingArquivos: false, // Controla o estado de carregamento dos arquivos
    arquivosProtocolo: [], // Lista de arquivos enviados no protocolo atual (vem da API)
    interacoes: [], // Lista de interações
    selectedInteracao: null, // Interação selecionada na tabela
    searchInteracoes: "", // Texto para filtrar interações na tabela
    filtroDataInicio: "", // Data de início para filtro (formato ISO)
    filtroDataFim: "", // Data de fim para filtro (formato ISO)
    menuDataInicio: false, // Controla a exibição do date picker de data início
    menuDataFim: false, // Controla a exibição do date picker de data fim
    arquivosHeaders: [
      { text: "ID", value: "id", width: "10%" },
      { text: "Informações", value: "info", sortable: false },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],

    interacoesHeaders: [
      { text: "ID", value: "idInteracao" },
      { text: "Data", value: "dtInteracao" },
      { text: "Cliente", value: "cliente" },
      { text: "Telefone", value: "telefone" },
      { text: "Status", value: "status", sortable: false },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
    ],

    // Transferência de atendimento
    showTransferDialog: false,
    showParticipantDialog: false,
    searchColaborador: "",
    colaboradores: [],
    selectedColaboradores: [],
    loadingColaboradores: false,
    transferringAttendance: false,
    addingParticipant: false,
    removingParticipant: false,
    colaboradoresHeaders: [
      { text: "Nome", value: "nome", align: "start" },
      { text: "E-mail", value: "email" },
      { text: "Departamento", value: "departamento" },
    ],

    // Transferência de fila
    showTransferFilaDialog: false,
    filaDestinoSelecionada: null,
    transferindoFila: false,
  }),

  computed: {
    // Retorna o telefone da empresa baseado na seleção
    telefoneEmpresa() {
      // Se não houver empresa selecionada ou for "Todas", usa o padrão
      if (!this.selectedEmpresa || this.selectedEmpresa === "Todas") {
        return "558282308177"; // Padrão (Previda)
      }

      // Pega a primeira empresa selecionada (ou a última se múltiplas)
      const empresaAtual = this.selectedEmpresa;

      // Mapeamento de empresa para telefone (usando os nomes exatos do filtro)
      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
        "A FLOR DO CAFÉ": "558000829000",
        "a flor do café": "558000829000",
      };

      // Função para normalizar string (remove acentos e converte para maiúscula)
      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      // Tenta encontrar correspondência exata primeiro
      if (mapeamentoEmpresas[empresaAtual]) {
        return mapeamentoEmpresas[empresaAtual];
      }

      // Tenta com uppercase
      const empresaUpper = empresaAtual.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      // Tenta com normalização (sem acentos)
      const empresaNormalizada = normalizar(empresaAtual);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      // Se não encontrou, verifica se contém palavras-chave
      // Empresas de cemitério não possuem telefone de WhatsApp cadastrado
      if (empresaNormalizada.includes("CEMITERIO")) {
        return "558000829000";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "558000829000";
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      // Retorna null se não encontrou correspondência (empresa sem telefone cadastrado)
      console.warn(
        "Empresa não mapeada:",
        empresaAtual,
        "Sem telefone cadastrado",
      );
      return null;
    },

    // Verifica se uma empresa válida foi selecionada
    empresaSelecionada() {
      // Empresa está selecionada quando o filtro está escondido e há empresas selecionadas
      return !this.showFiltroEmpresa && this.selectedEmpresa;
    },

    // Número de clientes retornados pela API
    clientsCount() {
      return this.clients ? this.clients.length : 0;
    },

    // Número de clientes retornados pela API para o diálogo
    clientsDialogCount() {
      return this.clientsDialog ? this.clientsDialog.length : 0;
    },

    // Tipos de interação disponíveis para o cliente
    interactionTypes() {
      return [
        { value: 1, label: "Atendimento" },
        { value: 2, label: "Venda" },
        { value: 3, label: "Informação" },
        { value: 5, label: "Cobrança" },
      ];
    },

    // Contratos disponíveis do cliente selecionado na barra lateral
    availableClientContracts() {
      if (!this.clientInfo || !this.clientInfo.contratos) return [];

      return this.clientInfo.contratos.map((c) => ({
        id: c.id,
        label: c.referencia
          ? `${c.tipo || "Contrato"} - ${c.referencia}`
          : c.tipo || "Contrato",
      }));
    },

    // Formatação da data de início no formato brasileiro
    filtroDataInicioFormatada: {
      get() {
        if (!this.filtroDataInicio) return "";
        const [year, month, day] = this.filtroDataInicio.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        // Quando o campo é editado manualmente, não fazemos nada
        // pois o campo é readonly e só é alterado pelo date picker
      },
    },

    // Formatação da data de fim no formato brasileiro
    filtroDataFimFormatada: {
      get() {
        if (!this.filtroDataFim) return "";
        const [year, month, day] = this.filtroDataFim.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        // Quando o campo é editado manualmente, não fazemos nada
        // pois o campo é readonly e só é alterado pelo date picker
      },
    },

    activeTemplates() {
      if (!this.templates || !this.templates.length) return [];

      // Filter only active templates
      return this.templates.filter(
        (template) =>
          template.status_cliente === "ATIVO" &&
          template.status_broker === "APPROVED",
      );
    },

    // Obter nome do usuário logado
    loggedUserName() {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user ? user.nome : null;
      } catch (error) {
        console.error("Erro ao obter nome do usuário:", error);
        return null;
      }
    },

    isAdmin() {
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (!user || !user.roles) return false;

      const rolesAdmin = ["ROLE_ADMIN", "ROLE_FINALIZAR_PROTOCOLOS_CAMPANHA"];

      return user.roles.some((role) => rolesAdmin.includes(role));
    },

    // Verificar se o usuário logado é o atendente do protocolo atual
    isCurrentUserAttendant() {
      if (!this.selectedProtocolData || !this.loggedUserName) {
        return false;
      }
      return this.selectedProtocolData.emAtendimento === this.loggedUserName;
    },

    // Verificar se o usuário logado é participante do protocolo atual
    isCurrentUserParticipant() {
      if (!this.selectedProtocolData || !this.loggedUserName) {
        return false;
      }
      return this.selectedProtocolData.visitante === this.loggedUserName;
    },

    // Label dinâmico para o campo de busca baseado no tipo selecionado
    labelBusca() {
      switch (this.tipoBusca) {
        case "telefone":
          return "Número de telefone";
        case "nome":
          return "Nome do cliente";
        case "cpf":
          return "CPF do cliente";
        default:
          return "Valor para busca";
      }
    },

    // Verifica se todos os parâmetros do template estão preenchidos
    allParametersFilled() {
      if (!this.selectedTemplate) return false;

      const params = this.extractTemplateParams(this.selectedTemplate.content);
      if (params.length === 0) return true; // Se não tiver parâmetros, está ok

      // Verifica se todos os parâmetros têm algum valor preenchido
      return this.templateParams.every((param, index) => {
        return index >= params.length || (param && param.trim() !== "");
      });
    },

    // Protocolos filtrados por busca e status
    filteredProtocols() {
      let filtered = [...this.openProtocols];

      // Para protocolos abertos, filtrar apenas os que têm o atendente igual ao usuário logado
      // ou que não têm atendente atribuído (emAtendimento: null)
      // Protocolos fechados são exibidos normalmente (sem filtro por atendente)
      if (this.loggedUserName) {
        filtered = filtered.filter((protocol) => {
          // Se o protocolo está aberto
          if (protocol.status === "open") {
            // Se o filtro "Meus Tickets" está ativado, mostrar apenas os protocolos onde o usuário é atendente ou visitante
            if (this.meusAtendimentos) {
              return (
                protocol.emAtendimento === this.loggedUserName ||
                protocol.visitante === this.loggedUserName
              );
            } else {
              // Comportamento padrão: mostrar se não tem atendente atribuído (null) ou se o atendente é o usuário logado
              return (
                protocol.emAtendimento === null ||
                protocol.emAtendimento === this.loggedUserName ||
                protocol.visitante === this.loggedUserName
              );
            }
          }
          // Se está fechado, mostrar todos (sem filtro por atendente) ou apenas os do usuário se meusAtendimentos estiver ativado
          return (
            !this.meusAtendimentos ||
            protocol.emAtendimento === this.loggedUserName ||
            protocol.visitante === this.loggedUserName
          );
        });
      }

      // Filtrar por busca (protocolo ou contato)
      if (this.protocolSearch && this.protocolSearch.trim() !== "") {
        const searchTerm = this.protocolSearch.toLowerCase().trim();

        filtered = filtered.filter((protocol) => {
          // Buscar no número do protocolo
          const protocoloMatch = protocol.protocolo
            ? protocol.protocolo.toLowerCase().includes(searchTerm)
            : false;

          // Buscar no número do contato
          const contatoMatch = protocol.numeroDoContato
            ? protocol.numeroDoContato.toLowerCase().includes(searchTerm)
            : false;

          return protocoloMatch || contatoMatch;
        });
      }

      return filtered;
    },

    // Retorna o objeto da fila atualmente selecionada
    filaSelecionada() {
      if (!this.filas || !this.filas.length || !this.selectedFilaId) {
        return null;
      }
      return this.filas.find((fila) => fila.id === this.selectedFilaId) || null;
    },

    // Retorna a fila atual do protocolo selecionado
    filaAtualProtocolo() {
      if (!this.selectedProtocolData) {
        return null;
      }

      // Verificar diferentes possíveis nomes de campo
      const filaId = this.selectedFilaId; // Fallback para a fila do filtro

      console.log(this.selectedFilaId);
      console.log("filaId encontrado:", filaId);

      if (!filaId) {
        return null;
      }

      const fila = this.filas.find((f) => f.id === filaId);
      console.log("fila encontrada:", fila);

      return fila ? fila.nomeFila : null;
    },

    // Retorna as filas disponíveis (diferentes da fila atual do protocolo)
    filasDisponiveis() {
      if (!this.filas || !this.filas.length) {
        return [];
      }
      // Se não há fila selecionada, mostrar todas as filas
      if (!this.selectedFilaId) {
        return this.filas;
      }
      // Filtrar filas diferentes da fila atual
      return this.filas.filter((fila) => fila.id !== this.selectedFilaId);
    },
  },

  created() {
    this.authenticate();
  },

  watch: {
    protocolStatusFilter(val) {
      if (val) {
        this.fetchOpenProtocols();
      }
    },
    isAuthenticated(val) {
      // Não buscar protocolos automaticamente na autenticação
      // Agora é obrigatório selecionar uma empresa primeiro
      // Os protocolos serão carregados quando o usuário filtrar por empresa
    },

    phoneNumber(val) {
      if (this.tipoBusca === "telefone") {
        this.valorBusca = val;
      }

      // Chamar a rota para preencher os parâmetros quando o telefone mudar
      if (val && val.length >= 8) {
        this.autoPreencherParams();
      }
    },
  },

  mounted() {
    // Iniciar consulta periódica se já tiver um protocolo
    if (this.currentProtocol) {
      this.startMessagePolling();
    }
  },

  beforeDestroy() {
    // Limpar intervalo quando o componente for destruído
    this.stopMessagePolling();
  },

  methods: {
    async confirmarFinalizacaoCampanha() {
      this.loadingFinalizarProtocolosCampanha = true;
      this.resultadoFinalizacao = null;

      try {
        const { data } = await SonaxService.finalizarCampanha(
          this.telefoneEmpresa,
          this.campanhaName,
        );

        // backend já decide a mensagem
        this.resultadoFinalizacao = data;
        this.campanhaName = "";
      } catch (err) {
        // erro de rede / 500 / auth / etc
        this.resultadoFinalizacao =
          err.response?.data || "Erro ao comunicar com o servidor";
      } finally {
        this.loadingFinalizarProtocolosCampanha = false;
      }
    },
    // Método para verificar se uma empresa tem telefone cadastrado
    verificarTelefoneEmpresa(empresa) {
      if (!empresa || empresa === "Todas") {
        return "558282308177"; // Padrão (Previda)
      }

      // Mapeamento de empresa para telefone
      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
        "A FLOR DO CAFÉ": "558000829000",
        "a flor do café": "558000829000",
      };

      // Função para normalizar string (remove acentos e converte para maiúscula)
      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      // Tenta encontrar correspondência exata primeiro
      if (mapeamentoEmpresas[empresa]) {
        return mapeamentoEmpresas[empresa];
      }

      // Tenta com uppercase
      const empresaUpper = empresa.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      // Tenta com normalização (sem acentos)
      const empresaNormalizada = normalizar(empresa);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      // Se não encontrou, verifica se contém palavras-chave
      // Empresas de cemitério não possuem telefone de WhatsApp cadastrado
      if (empresaNormalizada.includes("CEMITERIO")) {
        return null;
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      // Retorna null se não encontrou correspondência
      return null;
    },

    // Método para lidar com o filtro de empresa
    async filterDataEmpresa(filterData) {
      const empresasSelecionada = filterData.selectedCompany || null;

      // Verificar se pelo menos uma empresa foi selecionada
      if (!empresasSelecionada) {
        return;
      }

      // Verificar se a empresa selecionada tem telefone cadastrado ANTES de atribuir
      const telefone = this.verificarTelefoneEmpresa(empresasSelecionada);
      if (!telefone) {
        // Armazenar o nome da empresa para exibir no diálogo
        this.empresaSemTelefone = empresasSelecionada;
        // Mostrar diálogo informando que não há telefone cadastrado
        this.showNoPhoneDialog = true;
        // NÃO atribuir à selectedEmpresas - não permitir seleção
        return;
      }

      // Se tem telefone, então permite a seleção
      this.selectedEmpresa = empresasSelecionada;
      console.log("Empresas selecionadas:", this.empresasSelecionada);

      // Esconder o filtro e mostrar a empresa selecionada
      this.showFiltroEmpresa = false;

      // Carregar filas, protocolos e templates automaticamente após filtrar a empresa
      if (this.isAuthenticated) {
        await this.fetchFilaTemplatesEmpresa(empresasSelecionada);
        await Promise.all([this.fetchOpenProtocols(), this.fetchTemplates()]);
      }
    },

    async fetchFilaTemplatesEmpresa(empresa) {
      if (!empresa) {
        return;
      }
      try {
        const response = await SonaxService.listarFilaTemplatesEmpresa(empresa);
        if (response.data && !response.data.error && response.data) {
          const filas = response.data;
          this.filas = filas;

          // Seleciona a primeira fila por padrão, caso nenhuma esteja selecionada
          if (filas.length) {
            const primeiraFilaId = filas[0].id;
            if (
              !this.selectedFilaId ||
              !filas.some((f) => f.id === this.selectedFilaId)
            ) {
              this.selectedFilaId = primeiraFilaId;
            }
          } else {
            this.selectedFilaId = null;
          }
        }
      } catch (error) {
        console.error("Erro ao carregar filas template:", error);
      }
    },

    // Ao selecionar uma fila no menu suspenso
    onSelecionarFila(fila) {
      this.selectedFilaId = fila.id;
      this.filaMenu = false;
      // Recarrega os protocolos já considerando a nova fila selecionada
      this.fetchOpenProtocols();
    },

    notificarMensagemNova() {
      const audio = new Audio(require("@/assets/sounds/alerta.wav"));
      console.log("notificação de mensagem enviada!");
      audio.play().catch((error) => {
        console.error("Erro ao reproduzir som de alerta:", error);
      });
    },

    // Métodos para anexo de arquivo
    openFileAttachmentDialog() {
      this.showFileAttachmentDialog = true;
      this.selectedFile = null;
      this.selectedFileName = "";
      this.selectedFileSize = 0;
      this.fileError = null;
    },

    closeFileAttachmentDialog() {
      this.showFileAttachmentDialog = false;
      this.selectedFile = null;
      this.selectedFileName = "";
      this.selectedFileSize = 0;
      this.fileError = null;
    },

    // Métodos de gravação de áudio
    openAudioDialog() {
      this.dialogAudio = true;
      this.resetarEstadoAudio();
      this.solicitarPermissaoMicrofone();
    },

    fecharDialogAudio() {
      if (this.isRecording) {
        this.pararGravacao();
      }
      this.resetarEstadoAudio();
      this.dialogAudio = false;
    },

    resetarEstadoAudio() {
      if (this.audioURL) {
        URL.revokeObjectURL(this.audioURL);
      }
      if (this.audioTimer) {
        clearInterval(this.audioTimer);
      }
      this.audioRecorder = null;
      this.isRecording = false;
      this.audioBlob = null;
      this.audioURL = null;
      this.audioDuration = 0;
      this.audioTimer = null;
    },

    solicitarPermissaoMicrofone() {
      this.solicitandoPermissao = true;

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.permissaoMicrofone = true;
          this.prepararGravador(stream);
        })
        .catch((error) => {
          console.error("Erro ao solicitar permissão de microfone:", error);
          this.permissaoMicrofone = false;
        })
        .finally(() => {
          this.solicitandoPermissao = false;
        });
    },

    prepararGravador(stream) {
      try {
        // Tentar usar MP3/MPEG primeiro (formato mais compatível com WhatsApp)
        const mimeTypes = [
          "audio/mpeg",
          "audio/mp3",
          "audio/ogg;codecs=opus",
          "audio/ogg",
          "audio/webm;codecs=opus",
          "audio/webm",
        ];

        let selectedMimeType = "audio/webm";
        for (const mimeType of mimeTypes) {
          if (MediaRecorder.isTypeSupported(mimeType)) {
            selectedMimeType = mimeType;
            console.log("🎤 MimeType selecionado:", mimeType);
            break;
          }
        }

        this.audioMimeType = selectedMimeType;
        const options = { mimeType: selectedMimeType };
        this.audioRecorder = new MediaRecorder(stream, options);

        this.audioRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            const chunks = [];
            chunks.push(event.data);
            this.audioBlob = new Blob(chunks, { type: selectedMimeType });
            this.audioURL = URL.createObjectURL(this.audioBlob);
          }
        };

        this.audioRecorder.onstop = () => {
          stream.getTracks().forEach((track) => track.stop());
        };
      } catch (error) {
        console.error("Erro ao preparar gravador:", error);
      }
    },

    iniciarGravacao() {
      if (!this.audioRecorder) return;

      try {
        this.audioRecorder.start();
        this.isRecording = true;
        this.audioDuration = 0;

        this.audioTimer = setInterval(() => {
          this.audioDuration++;
          // limitado a 2min
          if (this.audioDuration >= 120) {
            this.pararGravacao();
          }
        }, 1000);
      } catch (error) {
        console.error("Erro ao iniciar gravação:", error);
      }
    },

    pararGravacao() {
      if (!this.audioRecorder || this.audioRecorder.state === "inactive")
        return;

      try {
        this.audioRecorder.stop();
        this.isRecording = false;

        if (this.audioTimer) {
          clearInterval(this.audioTimer);
        }
      } catch (error) {
        console.error("Erro ao parar gravação:", error);
      }
    },

    descartarAudio() {
      this.resetarEstadoAudio();
      this.solicitarPermissaoMicrofone();
    },

    formatAudioTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    async enviarAudio() {
      if (!this.audioBlob || !this.currentProtocol) {
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.fileError = "Número de telefone não encontrado";
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.enviandoAudio = true;

      // Enviar sempre em WEBM
      const fileName = `Audio_${this.formatAudioTime(this.audioDuration)}.webm`;

      console.log("📤 Enviando áudio WEBM:", {
        fileName,
        size: this.audioBlob.size,
      });

      const audioFile = new File([this.audioBlob], fileName, {
        type: "audio/webm",
      });
      try {
        // Enviar áudio usando a mesma rota de arquivos
        const response = await SonaxService.sendMessageFile({
          protocolo: this.currentProtocol,
          to: telefoneFormatado,
          empresa: this.selectedEmpresa,
          from: this.telefoneEmpresa,
          file: audioFile,
          isAudio: true,
        });

        if (response.data && !response.data.error) {
          // Fechar diálogo de áudio
          this.fecharDialogAudio();

          // Verificar se há URL no retorno
          if (response.data.message) {
            // Armazenar a URL do arquivo
            this.fileUrl = response.data.message;

            // Mostrar diálogo de sucesso
            this.showFileUrlDialog = true;

            // Fechar automaticamente após 5 segundos
            setTimeout(() => {
              this.closeFileUrlDialog();
            }, 5000);
          }

          // Atualizar mensagens sem mostrar o loader
          await this.fetchMessagesWithoutLoading();
        } else {
          console.error("Erro ao enviar áudio:", response.data);
        }
      } catch (error) {
        console.error("Erro ao enviar áudio:", error);
      } finally {
        this.enviandoAudio = false;
      }
    },

    closeFileUrlDialog() {
      this.showFileUrlDialog = false;
      this.fileUrl = "";
    },

    copiarLinkArquivo() {
      if (!this.fileUrl) return;

      navigator.clipboard
        .writeText(this.fileUrl)
        .then(() => {
          this.$store?.dispatch("showSnackbar", {
            text: "Link copiado para a área de transferência",
            color: "success",
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar link:", err);
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar link",
            color: "error",
          });
        });
    },

    handleFileChange(file) {
      if (!file) {
        this.selectedFile = null;
        this.selectedFileName = "";
        this.selectedFileSize = 0;
        return;
      }

      // Verificar tamanho do arquivo (máximo 10MB)
      if (file.size > 10000000) {
        this.fileError = "O arquivo deve ter menos de 10MB";
        return;
      }

      this.selectedFileName = file.name;
      this.selectedFileSize = file.size;
      this.fileError = null;
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    async sendAttachedFile() {
      if (!this.selectedFile || !this.currentProtocol) {
        this.fileError =
          "Selecione um arquivo e certifique-se de que há um protocolo ativo";
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.fileError = "Número de telefone não encontrado";
        return;
      }

      // Validar se uma empresa foi selecionada
      if (!this.selectedEmpresa) {
        this.$store?.dispatch("showSnackbar", {
          text: "Por favor, selecione uma empresa no filtro antes de enviar mensagens.",
          color: "warning",
        });
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingFile = true;

      try {
        // Enviar arquivo
        const response = await SonaxService.sendMessageFile({
          protocolo: this.currentProtocol,
          to: telefoneFormatado,
          empresa: this.selectedEmpresa,
          from: this.telefoneEmpresa,
          file: this.selectedFile,
        });

        if (response.data && !response.data.error) {
          // Fechar diálogo de anexo
          this.closeFileAttachmentDialog();

          // Verificar se há URL no retorno
          if (response.data.message) {
            // Armazenar a URL do arquivo
            this.fileUrl = response.data.message;

            // Mostrar diálogo
            this.showFileUrlDialog = true;

            // Fechar automaticamente após 5 segundos
            setTimeout(() => {
              this.closeFileUrlDialog();
            }, 5000);
          }

          // Atualizar mensagens sem mostrar o loader
          await this.fetchMessagesWithoutLoading();
        } else {
          this.fileError = response.data?.message || "Erro ao enviar arquivo";
        }
      } catch (error) {
        console.error("Erro ao enviar arquivo:", error);
        this.fileError =
          error.response?.data?.message ||
          error.message ||
          "Erro ao enviar arquivo";
      } finally {
        this.sendingFile = false;
      }
    },

    handleEnter(event) {
      // Shift + Enter → quebra linha
      if (event.shiftKey) {
        return;
      }

      // Enter → envia mensagem
      event.preventDefault();

      this.sendFreeTextMessageHandler();
    },

    async sendFreeTextMessageHandler() {
      // Validações
      if (
        this.sendingMessage ||
        !this.freeTextMessage ||
        !this.freeTextMessage.trim() ||
        (!this.isCurrentUserAttendant && !this.isCurrentUserParticipant)
      ) {
        return;
      }

      this.sendingMessage = true;

      try {
        await this.sendFreeTextMessage();
        this.freeTextMessage = "";

        // Volta o foco para o textarea
        this.$nextTick(() => {
          this.$refs.textareaRef?.focus();
        });
      } catch (e) {
        console.error("Erro ao enviar mensagem:", e);
      } finally {
        this.sendingMessage = false;
      }
    },
    async authenticate() {
      try {
        const response = await SonaxService.authenticate();

        if (response.data && !response.data.error) {
          // Token não é mais necessário, backend gerencia
          this.isAuthenticated = true;
          // Templates serão carregados quando o usuário filtrar por empresa
        } else {
          this.authError = response.data?.message || "Falha na autenticação";
        }
      } catch (error) {
        console.error("Erro na autenticação:", error);
        this.authError =
          error.response?.data?.message ||
          error.message ||
          "Erro na autenticação";
      }
    },

    async fetchTemplates() {
      // Validar se uma empresa foi selecionada
      if (!this.selectedEmpresa) {
        this.$store?.dispatch("showSnackbar", {
          text: "Por favor, selecione uma empresa no filtro antes de buscar templates.",
          color: "warning",
        });
        return;
      }

      this.loadingTemplates = true;
      try {
        const response = await SonaxService.getTemplates(this.telefoneEmpresa);

        if (
          response.data &&
          !response.data.error &&
          response.data.data &&
          response.data.data.brokers &&
          response.data.data.brokers.length > 0
        ) {
          // Procurar o broker que corresponde ao telefoneEmpresa usado na requisição
          let brokerEncontrado = response.data.data.brokers.find(
            (broker) => broker.number === this.telefoneEmpresa,
          );

          // Se não encontrar o broker específico, pegar o primeiro broker que tenha templates
          if (
            !brokerEncontrado ||
            !brokerEncontrado.templates ||
            brokerEncontrado.templates.length === 0
          ) {
            brokerEncontrado = response.data.data.brokers.find(
              (broker) => broker.templates && broker.templates.length > 0,
            );
          }

          // Se encontrou um broker com templates, extrair os templates
          if (
            brokerEncontrado &&
            brokerEncontrado.templates &&
            brokerEncontrado.templates.length > 0
          ) {
            const brokerNumber = brokerEncontrado.number;
            this.templates = brokerEncontrado.templates.map((template) => ({
              ...template,
              brokerNumber, // Adicionar o número do broker a cada template
            }));
            console.log("Templates carregados:", this.templates.length);
          } else {
            // Se não encontrou templates, inicializar como array vazio
            this.templates = [];
            console.log(
              "Nenhum template encontrado para o telefone:",
              this.telefoneEmpresa,
            );
          }
        } else {
          this.templates = [];
        }
      } catch (error) {
        console.error("Erro ao buscar templates:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar templates",
          color: "error",
        });
        this.templates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },

    selectTemplate(template) {
      this.selectedTemplate = template;
      this.selectedTemplateId = template._id;
      // Reset template params
      this.templateParams = new Array(
        this.extractTemplateParams(template.content).length,
      ).fill("");
      // Reset template param labels
      this.templateParamLabels = new Array(
        this.extractTemplateParams(template.content).length,
      ).fill("");
      // Ocultar conteúdo ao trocar template
      this.showTemplateContent = false;
    },

    // Handler quando template é selecionado no select
    onTemplateSelectChange(templateId) {
      if (templateId) {
        const template = this.activeTemplates.find((t) => t._id === templateId);
        if (template) {
          this.selectTemplate(template);
        }
      } else {
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.templateParams = [];
        this.templateParamLabels = [];
        this.showTemplateContent = false;
      }
    },

    autoPreencherParams() {
      if (
        this.selectedTemplate &&
        this.phoneNumber &&
        this.phoneNumber.length >= 9
      ) {
        this.preencherParamsTemplate();
      }
    },

    // Preencher parâmetros do template usando a API
    async preencherParamsTemplate() {
      if (
        !this.selectedTemplate ||
        !this.phoneNumber ||
        this.phoneNumber.length < 8
      ) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um template e informe o telefone",
          color: "warning",
        });
        return;
      }

      try {
        // Formatar telefone (remover prefixo +55 se existir)
        const telefoneFormatado = this.phoneNumber.replace(/^\+?55/, "");

        const response = await SonaxService.preencherParametros(
          this.selectedTemplate.name,
          telefoneFormatado,
        );

        if (response.data && Array.isArray(response.data)) {
          // Preencher os valores dos parâmetros
          const params = this.extractTemplateParams(
            this.selectedTemplate.content,
          );

          // Resetar arrays
          this.templateParams = new Array(params.length).fill("");
          this.templateParamLabels = new Array(params.length).fill("");

          // Preencher com os valores retornados da API
          response.data.forEach((item) => {
            const paramIndex = item.numeroParametro - 1;
            if (paramIndex >= 0 && paramIndex < params.length) {
              this.templateParams[paramIndex] = item.valorPreenchido || "";
              this.templateParamLabels[paramIndex] =
                item.label || `Parâmetro ${paramIndex + 1}`;
            }
          });

          this.$store?.dispatch("showSnackbar", {
            text: "Parâmetros preenchidos com sucesso",
            color: "success",
          });
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Nenhum parâmetro encontrado para este template",
            color: "info",
          });
        }
      } catch (error) {
        console.error("Erro ao preencher parâmetros:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao preencher parâmetros",
          color: "error",
        });
      }
    },

    extractTemplateParams(content) {
      const regex = /\{\{(\d+)\}\}/g;
      const params = [];
      let match;

      while ((match = regex.exec(content)) !== null) {
        params.push(match[1]);
      }

      return [...new Set(params)].sort((a, b) => a - b);
    },

    // Interpretar status do ACK
    // ACK "1" = Enviado, ACK "2" = Entregue, ACK "3" = Lido, ACK "-2" = Erro
    interpretarStatus(ack) {
      switch (ack) {
        case "0":
        case "1":
          return {
            status: "sent",
            label: "Enviado",
            isDelivered: false,
            isRead: false,
          };
        case "2":
          return {
            status: "delivered",
            label: "Entregue",
            isDelivered: true,
            isRead: false,
          };
        case "3":
          return {
            status: "read",
            label: "Lido",
            isDelivered: true,
            isRead: true,
          };
        case "-2":
          return {
            status: "error",
            label: "Erro",
            isDelivered: false,
            isRead: false,
          };
        default:
          return {
            status: "sent",
            label: "Enviado",
            isDelivered: false,
            isRead: false,
          };
      }
    },

    // Processar mensagens para adicionar status baseado no ACK
    processarStatusMensagens(mensagens) {
      return mensagens.map((mensagem) => {
        // Apenas processar mensagens enviadas que têm ACK
        if (
          mensagem.direction === "outgoing" &&
          mensagem.ack !== undefined &&
          mensagem.ack !== null
        ) {
          const statusInfo = this.interpretarStatus(mensagem.ack);
          return {
            ...mensagem,
            readStatus: statusInfo.status,
            isDelivered: statusInfo.isDelivered,
            isRead: statusInfo.isRead,
            statusLabel: statusInfo.label,
          };
        }
        return mensagem;
      });
    },

    // Verificar contato antes de enviar mensagem
    async checkContactAndSend() {
      if (!this.$refs.form.validate()) return;

      // Validar telefone
      if (!this.phoneNumber) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone é obrigatório",
          color: "error",
        });
        return;
      }

      this.checkingContact = true;

      try {
        // Formatar telefone com prefixo 55
        const telefoneFormatado = this.phoneNumber.startsWith("55")
          ? this.phoneNumber.replace("55", "")
          : this.phoneNumber;

        // Buscar protocolos por telefone
        const response = await SonaxService.getProtocolsByPhone(
          telefoneFormatado,
          this.telefoneEmpresa,
        );

        console.log("Resposta da busca de protocolos:", response.data);

        if (response.data) {
          // Verificar se há protocolos abertos (status === "open")
          const protocolosAbertos = Array.isArray(response.data)
            ? response.data.filter((protocolo) => protocolo.status === "open")
            : [];

          if (protocolosAbertos.length > 0) {
            console.log(
              "Protocolo aberto detectado! Bloqueando envio de mensagem.",
            );
            // Mostrar diálogo informando sobre protocolo existente
            const ultimoProtocolo = protocolosAbertos[0]; // Pegar o primeiro protocolo aberto
            this.contactInfo = {
              data: {
                numeroTelefone: telefoneFormatado,
                protocolosAbertos: protocolosAbertos,
                ultimoProtocolo: ultimoProtocolo,
                protocolNumber: ultimoProtocolo.protocolNumber,
                numeroDoContato: ultimoProtocolo.numeroDoContato,
                dataCreate: ultimoProtocolo.dataCreate,
                userInsert: ultimoProtocolo.userInsert,
              },
            };
            this.showProtocolDialog = true;
            this.checkingContact = false;
            return; // IMPORTANTE: retorna aqui para não prosseguir com o envio
          } else {
            console.log(
              "Nenhum protocolo aberto encontrado, prosseguindo com envio...",
            );
          }
        }

        // Se não tem protocolo aberto, prosseguir com o envio
        console.log("Prosseguindo com proceedWithSend()...");
        await this.proceedWithSend();
      } catch (error) {
        console.error("Erro ao verificar contato:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao verificar contato",
          color: "error",
        });
      } finally {
        this.checkingContact = false;
      }
    },

    // Fechar diálogo de novo atendimento
    closeNewAttendanceDialog() {
      this.showNewAttendanceDialog = false;
      // Limpar formulário
      this.phoneNumber = "";
      this.selectedTemplateId = null;
      this.selectedTemplate = null;
      this.templateParams = [];
      this.templateParamLabels = [];
      this.showTemplateContent = false;
      this.tipoBusca = "telefone";
      this.clienteSelecionado = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    // Fechar diálogo de protocolo existente
    closeProtocolDialog() {
      this.showProtocolDialog = false;
      this.contactInfo = null;
    },

    // Prosseguir com o envio da mensagem
    async proceedWithSend() {
      this.sendingMessage = true;

      try {
        // Format params as comma-separated string
        const paramsTemplate = this.templateParams
          .map((p) => p.trim())
          .join(",");

        // Obter ID e nome do cliente (de clienteSelecionado ou da interação selecionada)
        let clienteId = null;
        let clienteNome = null;

        // Verificar se temos um cliente selecionado no diálogo de atendimento
        if (this.clienteSelecionado) {
          clienteId = this.clienteSelecionado.idCliente;
          clienteNome = this.clienteSelecionado.nome;
        }
        // Verificar se temos uma interação selecionada na tabela de interações
        else if (this.selectedInteracao) {
          clienteId = this.selectedInteracao.idCliente;
          clienteNome = this.selectedInteracao.cliente;
        }

        const response = await SonaxService.sendMessage({
          message: this.selectedTemplate.name,
          to: this.phoneNumber,
          from: this.selectedTemplate.brokerNumber,
          empresa: this.selectedEmpresa,
          paramsTemplate,
          primeiroContato: true, // Mensagem do diálogo de novo atendimento
          clienteId, // Adicionar ID do cliente
          clienteNome, // Adicionar nome do cliente
        });

        if (response.data && !response.data.error && response.data.protocol) {
          this.currentProtocol = response.data.protocol.protocol_number;
          this.$nextTick(async () => {
            // Atualizar lista de protocolos primeiro
            await this.fetchOpenProtocols();

            // Encontrar o protocolo recém-criado na lista atualizada e atualizar selectedProtocolData
            const newProtocol = this.openProtocols.find(
              (p) => p.protocolo === this.currentProtocol,
            );
            if (newProtocol) {
              this.selectedProtocolData = newProtocol;
            }

            this.fetchMessages();
            // Iniciar consulta periódica de mensagens (a cada 1 minuto)
            this.startMessagePolling();
          });

          // Limpar formulário e fechar diálogo
          this.closeNewAttendanceDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    async fetchMessages() {
      if (!this.currentProtocol) return;

      this.loadingMessages = true;

      try {
        const response = await SonaxService.getMessages(this.currentProtocol);

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          this.messages = this.processarStatusMensagens(response.data.data);
          this.arquivosProtocolo = response.data.arquivos;

          // Se tiver mensagens, pegar o ID do protocolo da primeira mensagem
          if (
            this.messages.length > 0 &&
            this.messages[0].protocol &&
            this.messages[0].protocol._id
          ) {
            this.currentProtocolId = this.messages[0].protocol._id;
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar mensagens",
          color: "error",
        });
      } finally {
        this.loadingMessages = false;
      }
    },

    // Copiar URL para a área de transferência
    copiarUrl(url) {
      if (!url) return;

      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$store?.dispatch("showSnackbar", {
            text: "URL copiada para a área de transferência",
            color: "success",
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar URL: ", err);
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar URL",
            color: "error",
          });
        });
    },

    // Obter ícone para o tipo de arquivo
    getFileTypeIcon(type, url) {
      if (type !== "file") return "mdi-file-outline";

      if (this.isImage(url)) return "mdi-file-image-outline";
      if (this.isAudio(url)) return "mdi-file-music-outline";
      if (this.isVideo(url)) return "mdi-file-video-outline";
      return "mdi-file-document-outline";
    },

    // Obter cor para o tipo de arquivo
    getFileTypeColor(type, url) {
      if (type !== "file") return "grey";

      if (this.isImage(url)) return "primary";
      if (this.isAudio(url)) return "teal";
      if (this.isVideo(url)) return "purple"; // Cor para vídeos
      return "grey";
    },

    // Obter nome para o tipo de arquivo
    getFileTypeName(type, url) {
      if (type !== "file") return "Arquivo";

      if (this.isImage(url)) return "Imagem";
      if (this.isAudio(url)) return "Áudio";
      if (this.isVideo(url)) return "Vídeo";
      return "Arquivo";
    },

    refreshMessages() {
      this.fetchMessages();
    },

    // Iniciar consulta periódica de mensagens e protocolos
    startMessagePolling() {
      // Limpar quaisquer intervalos existentes
      this.stopMessagePolling();

      // Configurar intervalo para mensagens (a cada 10 segundos)
      this.messagePollingInterval = setInterval(() => {
        // Verificar mensagens se houver um protocolo atual
        if (this.currentProtocol) {
          this.fetchMessagesWithoutLoading();
        }
      }, 5000); // 10 segundos

      // Configurar intervalo para protocolos (a cada 2 minutos)
      this.protocolPollingInterval = setInterval(() => {
        // Atualizar a lista de protocolos sem mostrar o loading
        this.fetchOpenProtocols(false);
      }, 120000); // 120000 ms = 2 minutos
    },

    // Parar consultas periódicas
    stopMessagePolling() {
      // Limpar intervalo de mensagens
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }

      // Limpar intervalo de protocolos
      if (this.protocolPollingInterval) {
        clearInterval(this.protocolPollingInterval);
        this.protocolPollingInterval = null;
      }
    },

    // Enviar mensagem de texto livre
    async sendFreeTextMessage() {
      if (!this.freeTextMessage || !this.currentProtocol) return;

      // Validar se uma empresa foi selecionada
      if (!this.selectedEmpresa) {
        this.$store?.dispatch("showSnackbar", {
          text: "Por favor, selecione uma empresa no filtro antes de enviar mensagens.",
          color: "warning",
        });
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        this.sendingMessage = false;
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        // Para mensagens de texto livre, enviar paramsTemplate como string vazia
        // A API Sonax diferencia template (com paramsTemplate preenchido) de texto livre (paramsTemplate vazio)
        const messageData = {
          message: this.freeTextMessage,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : this.telefoneEmpresa,
          empresa: this.selectedEmpresa,
          paramsTemplate: "", // String vazia indica que é texto livre, não template
          primeiroContato: false, // Mensagem do chat (não é primeiro contato)
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          // Limpar a mensagem após envio
          this.freeTextMessage = "";

          // Atualizar mensagens sem mostrar o loader
          await this.fetchMessagesWithoutLoading();
        } else {
          // Verificar se o erro é relacionado a protocolo não existente
          const errorMessage = response.data?.message || "";
          if (
            errorMessage.includes("Não foi possível encontrar o template") ||
            errorMessage.includes("template informado")
          ) {
            this.$store?.dispatch("showSnackbar", {
              text: "Não é possível enviar texto livre sem um protocolo existente. Por favor, crie um novo atendimento com template primeiro.",
              color: "error",
            });
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: errorMessage || "Erro ao enviar mensagem",
              color: "error",
            });
          }
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem de texto:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Erro ao enviar mensagem";

        // Verificar se o erro é relacionado a protocolo não existente
        if (
          errorMessage.includes("Não foi possível encontrar o template") ||
          errorMessage.includes("template informado")
        ) {
          this.$store?.dispatch("showSnackbar", {
            text: "Não é possível enviar texto livre sem um protocolo existente. Por favor, crie um novo atendimento com template primeiro.",
            color: "error",
          });
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: errorMessage,
            color: "error",
          });
        }
      } finally {
        this.sendingMessage = false;
      }
    },

    // Buscar mensagens sem mostrar o loader
    async fetchMessagesWithoutLoading() {
      if (!this.currentProtocol) return;

      try {
        const response = await SonaxService.getMessages(this.currentProtocol);

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          const newMessages = this.processarStatusMensagens(response.data.data);

          // Verificar se há novas mensagens (comparar por IDs)
          const existingIds = new Set(this.messages.map((m) => m._id));
          const hasNewMessages = newMessages.some(
            (m) => !existingIds.has(m._id),
          );

          const hasNewIncomingMessage = newMessages.some(
            (m) => m.direction === "incoming" && !existingIds.has(m._id),
          );

          if (hasNewMessages) {
            // Atualizar lista completa
            this.messages = newMessages;
            // Rolar para o final da conversa
            this.scrollToBottom();
          } else {
            // Mesmo sem novas mensagens, atualizar para pegar mudanças de status
            this.messages = newMessages;
          }
          this.arquivosProtocolo = response.data.arquivos;

          if (hasNewIncomingMessage) {
            this.notificarMensagemNova();
          }

          // Se tiver mensagens, pegar o ID do protocolo da primeira mensagem
          if (
            newMessages.length > 0 &&
            newMessages[0].protocol &&
            newMessages[0].protocol._id
          ) {
            this.currentProtocolId = newMessages[0].protocol._id;
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
      }
    },

    // Alternar entre mostrar e esconder mensagens históricas
    async toggleHistoricalMessages() {
      // Se já está mostrando, apenas esconde
      if (this.showingHistoricalMessages) {
        this.showingHistoricalMessages = false;
        return;
      }

      // Se já tem mensagens históricas carregadas, apenas mostra
      if (this.historicalMessages.length > 0) {
        this.showingHistoricalMessages = true;
        return;
      }

      // Se não tem mensagens históricas, carrega e mostra
      await this.loadMoreMessages();
    },

    // Carregar mais mensagens (histórico)
    async loadMoreMessages() {
      if (
        !this.selectedProtocolData ||
        !this.selectedProtocolData.numeroDoContato
      ) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefone = this.selectedProtocolData.numeroDoContato.replace(
        /^\+?55/,
        "",
      );

      try {
        // Mostrar loading
        this.loadingMessages = true;

        // Buscar mensagens por telefone
        const response = await SonaxService.getMessagesByPhone(
          telefone,
          this.selectedEmpresa,
        );

        // Log simples para debug
        console.log(
          `Buscando histórico de mensagens para o telefone: ${telefone}`,
        );

        // Processar e adicionar mensagens do histórico ao chat
        if (response.data && response.data.mensagensPorProtocolo) {
          // Obter todas as mensagens de todos os protocolos
          let todasMensagens = [];

          // Iterar sobre cada protocolo e suas mensagens
          Object.keys(response.data.mensagensPorProtocolo).forEach(
            (protocolo) => {
              const mensagensDoProtocolo =
                response.data.mensagensPorProtocolo[protocolo];
              if (Array.isArray(mensagensDoProtocolo)) {
                // Processar cada mensagem para o formato esperado pelo chat
                const mensagensProcessadas = mensagensDoProtocolo.map(
                  (msg) => ({
                    _id: msg.messageId,
                    direction: msg.direction,
                    message: msg.message,
                    message_type: msg.messageType,
                    createdAt: msg.createdAt,
                    ack: msg.ack,
                    protocol: {
                      _id: msg.protocolId,
                      protocol_number: msg.protocolNumber,
                    },
                    userInsert: msg.userInsert,
                    isHistorical: true,
                    ...this.interpretarStatus(msg.ack),
                  }),
                );

                todasMensagens = [...todasMensagens, ...mensagensProcessadas];
              }
            },
          );

          // Ordenar mensagens por data (mais antigas primeiro)
          todasMensagens.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
          );

          // Verificar se já existem mensagens com os mesmos IDs para evitar duplicação
          const idsHistoricos = new Set(
            this.historicalMessages.map((m) => m._id),
          );
          const novasMensagens = todasMensagens.filter(
            (m) => !idsHistoricos.has(m._id),
          );

          if (novasMensagens.length > 0) {
            // Atualizar a lista de mensagens históricas
            this.historicalMessages = [
              ...this.historicalMessages,
              ...novasMensagens,
            ];

            // Ativar a exibição das mensagens históricas
            this.showingHistoricalMessages = true;

            this.$store?.dispatch("showSnackbar", {
              text: `${novasMensagens.length} mensagens históricas carregadas`,
              color: "success",
            });
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: "Nenhuma nova mensagem histórica encontrada",
              color: "info",
            });
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens por telefone:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message ||
            "Erro ao buscar mensagens por telefone",
          color: "error",
        });
      } finally {
        this.loadingMessages = false;
      }
    },

    toggleClientDetails() {
      // Se já está mostrando, apenas esconde
      if (this.showingClientDetails) {
        this.showingClientDetails = false;
        return;
      }

      // Se não está mostrando, mostra e busca informações do cliente
      this.showingClientDetails = true;
      this.fetchClientInfo();
    },

    // Função que recebe o telefone, consulta e abre o diálogo de informações do cliente
    async consultarClientePorTelefone(telefone) {
      if (!telefone || telefone.length < 8) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone inválido",
          color: "error",
        });
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefoneFormatado = telefone.replace(/^\+?55/, "");

      await this.consultarClientePorValor(telefoneFormatado, "telefone");
    },

    // Função genérica para consultar cliente por qualquer tipo de valor (telefone, nome, cpf)
    async consultarClientePorValor(valor, tipoBusca = "telefone") {
      this.loadingClientInfoDialog = true;
      this.clientInfoDialogError = null;
      this.showClientInfoDialog = true;

      try {
        // Busca informações do cliente com o tipo de busca especificado
        const response = await SonaxService.getClienteInfo(valor, tipoBusca);

        // Busca protocolos apenas se for busca por telefone
        let protocolosData = [];
        if (tipoBusca === "telefone") {
          const responseProtocolos = await SonaxService.getProtocolsByPhone(
            valor,
            this.telefoneEmpresa,
          );
          protocolosData = responseProtocolos.data || [];
        }

        if (response.data && response.data.length > 0) {
          // Armazena a lista completa de clientes
          this.clientsDialog = response.data;

          // Define o primeiro cliente como selecionado por padrão
          this.selectedClientDialogIndex = 0;

          // Define as informações do cliente selecionado
          this.updateSelectedClientDialogInfo(protocolosData);

          // Se houver apenas um cliente, seleciona automaticamente
          if (this.clientsDialog.length === 1) {
            // Define o cliente selecionado
            this.clienteSelecionado = this.clientInfoDialog;

            // Preenche o campo de telefone
            if (this.clientInfoDialog.telefone) {
              this.phoneNumber = this.clientInfoDialog.telefone;
            } else if (tipoBusca === "telefone") {
              this.phoneNumber = valor;
            }

            // Fecha o diálogo
            this.showClientInfoDialog = false;
          }
        } else {
          this.clientsDialog = [];
          this.clientInfoDialog = null;
          this.clientInfoDialogError =
            "Nenhuma informação disponível para este cliente";
        }
      } catch (error) {
        console.error("Erro ao buscar informações do cliente:", error);
        this.clientsDialog = [];
        this.clientInfoDialog = null;
        this.clientInfoDialogError =
          error.response?.data || "Erro ao buscar informações do cliente";
      } finally {
        this.loadingClientInfoDialog = false;
      }
    },

    // Método para atualizar as informações do cliente selecionado no diálogo
    // Similar ao updateSelectedClientInfo mas para o diálogo de consulta de cliente
    updateSelectedClientDialogInfo(protocolos = []) {
      if (
        this.clientsDialog.length > 0 &&
        this.selectedClientDialogIndex >= 0 &&
        this.selectedClientDialogIndex < this.clientsDialog.length
      ) {
        this.clientInfoDialog =
          this.clientsDialog[this.selectedClientDialogIndex];
        this.clientInfoDialog.protocolos = protocolos;
      } else {
        this.clientInfoDialog = null;
      }
    },

    // Método para mudar o cliente selecionado no diálogo
    // Similar ao changeSelectedClient mas para o diálogo de consulta de cliente
    changeSelectedClientDialog(index) {
      if (index >= 0 && index < this.clientsDialog.length) {
        this.selectedClientDialogIndex = index;
        this.updateSelectedClientDialogInfo(
          this.clientInfoDialog?.protocolos || [],
        );
      }
    },

    // Método para selecionar um cliente da tabela
    selectClientFromTable(item, index) {
      // Se o index não for fornecido diretamente, encontre o índice do item na lista
      if (index === undefined) {
        index = this.clientsDialog.findIndex(
          (client) =>
            client.idCliente === item.idCliente ||
            client.cpf === item.cpf ||
            client.telefone === item.telefone,
        );
      }

      // Se encontrou o índice, selecione o cliente
      if (index >= 0) {
        this.selectedClientDialogIndex = index;
        this.updateSelectedClientDialogInfo(
          this.clientInfoDialog?.protocolos || [],
        );

        // Se o cliente tiver telefone, preenche o campo de telefone
        if (item.telefone) {
          this.phoneNumber = item.telefone;
        }
      }
    },

    // Método para selecionar um cliente e fechar o diálogo
    selecionarEFecharDialog(item, index) {
      // Seleciona o cliente
      this.selectClientFromTable(item, index);

      // Define o cliente selecionado
      this.clienteSelecionado = this.clientInfoDialog;

      // Fecha o diálogo
      this.showClientInfoDialog = false;
    },

    // Método para editar informações do cliente
    editarCliente() {
      if (!this.clientInfoDialog) return;

      // Preencher o formulário de edição com os dados do cliente selecionado
      this.editClientContactForm = {
        idCliente: this.clientInfoDialog.idCliente,
        celular: this.clientInfoDialog.telefone || "",
        telefone: this.clientInfoDialog.telefone || "",
        email: this.clientInfoDialog.email || "",
        endereco: this.clientInfoDialog.endereco || "",
      };

      // Abrir o diálogo de edição
      this.showEditClientContactDialog = true;
    },

    // Método para trocar o cliente selecionado
    trocarCliente() {
      // Limpar o cliente selecionado
      this.clienteSelecionado = null;

      // Limpar o campo de telefone
      this.phoneNumber = "";
      this.valorBusca = "";
    },

    // Consultar ficha do cliente a partir do diálogo de novo atendimento
    async consultarFichaCliente(valor, tipoBusca = "telefone") {
      if (!valor) {
        this.$store?.dispatch("showSnackbar", {
          text: "Informe um valor para busca",
          color: "error",
        });
        return;
      }

      // Validação específica para telefone
      if (tipoBusca === "telefone" && valor.length < 8) {
        this.$store?.dispatch("showSnackbar", {
          text: "Informe um número de telefone válido",
          color: "error",
        });
        return;
      }

      await this.consultarClientePorValor(valor, tipoBusca);
    },

    // Buscar informações do cliente
    async fetchClientInfo() {
      if (
        !this.selectedProtocolData ||
        !this.selectedProtocolData.numeroDoContato
      ) {
        this.clientInfoError = "Número de telefone não encontrado";
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefone = this.selectedProtocolData.numeroDoContato.replace(
        /^\+?55/,
        "",
      );

      this.loadingClientInfo = true;
      this.clientInfoError = null;

      try {
        const response = await SonaxService.getClienteInfo(
          telefone,
          "telefone",
        );
        const responseProtocolos = await SonaxService.getProtocolsByPhone(
          telefone,
          this.telefoneEmpresa,
        );

        if (response.data && response.data.length > 0) {
          // Armazena a lista completa de clientes
          this.clients = response.data;

          // Define o primeiro cliente como selecionado por padrão
          this.selectedClientIndex = 0;

          // Define as informações do cliente selecionado
          this.updateSelectedClientInfo(responseProtocolos.data);
          this.loadingClientInfo = false;
        } else {
          this.clients = [];
          this.clientInfo = null;
          this.clientInfoError =
            "Nenhuma informação disponível para este cliente";
        }
      } catch (error) {
        console.error("Erro ao buscar informações do cliente:", error);
        this.clients = [];
        this.clientInfo = null;
        this.clientInfoError =
          error.response?.data || "Erro ao buscar informações do cliente";
      } finally {
        this.loadingClientInfo = false;
      }
    },

    /**
     * Abre o diálogo para adicionar interação do cliente,
     * inicializando o formulário com valores padrão.
     */
    openAddClientInteractionDialog() {
      if (!this.clientInfo || !this.clientInfo.idCliente) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um cliente antes de adicionar uma interação.",
          color: "error",
        });
        return;
      }

      this.addClientInteractionForm = {
        tipo: null,
        contratoId: null,
        descricao: "",
      };

      this.showAddClientInteractionDialog = true;
    },

    /**
     * Salva a interação do cliente na API iVertex (/sonax/ivertx/interacao).
     */
    async salvarInteracaoCliente() {
      if (!this.addClientInteractionForm.tipo) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione o tipo de interação.",
          color: "error",
        });
        return;
      }

      if (!this.addClientInteractionForm.contratoId) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um contrato.",
          color: "error",
        });
        return;
      }

      if (!this.addClientInteractionForm.descricao) {
        this.$store?.dispatch("showSnackbar", {
          text: "Informe a descrição da interação.",
          color: "error",
        });
        return;
      }

      this.savingClientInteraction = true;

      const idEntidade =
        this.clientInfo.idCliente || this.clientInfo.Id || null;

      // Nome do contato (cliente)
      const nomeContato =
        this.clientInfo.nome || this.clientInfo.NomeCompleto || "Não informado";

      // Assunto: usa apenas a referência do contrato selecionado, se existir
      let assunto = "Interação de cliente";
      if (this.clientInfo.contratos && this.clientInfo.contratos.length > 0) {
        const contratoSelecionado = this.clientInfo.contratos.find(
          (c) => c.id === this.addClientInteractionForm.contratoId,
        );
        if (contratoSelecionado) {
          assunto =
            contratoSelecionado.referencia ||
            contratoSelecionado.tipo ||
            assunto;
        }
      }

      try {
        const response = await SonaxService.salvarInteracaoCliente({
          idEntidade,
          tipo: this.addClientInteractionForm.tipo,
          nomeContato,
          assunto,
          descricaoInteracao: this.addClientInteractionForm.descricao,
        });

        const message =
          response?.data?.message || "Interação do cliente salva com sucesso.";

        this.clientInteractionResultMessage = message;
        this.showClientInteractionResultDialog = true;

        this.showAddClientInteractionDialog = false;
      } catch (error) {
        console.error("Erro ao salvar interação do cliente:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data || "Erro ao salvar a interação do cliente.",
          color: "error",
        });
      } finally {
        this.savingClientInteraction = false;
      }
    },

    /**
     * Abre o diálogo de edição de contato, preenchendo os campos
     * a partir do cliente atualmente selecionado em clientInfoDialog.
     */
    openEditClientContactDialogFromDialog() {
      if (!this.clientInfoDialog) return;
      this.prepareEditClientContactForm(this.clientInfoDialog);
      this.showEditClientContactDialog = true;
    },

    /**
     * Abre o diálogo de edição de contato a partir da barra lateral direita
     * (que usa clientInfo), buscando os dados detalhados na rota iVertex
     * /sonax/ivertx/cliente?cpf=...
     */
    async openEditClientContactDialogFromSidebar() {
      if (!this.clientInfo) return;

      // Tenta obter o CPF a partir do objeto clientInfo
      let cpf =
        this.clientInfo.cpf ||
        this.clientInfo.Inscricao_Ativa ||
        this.clientInfo.cpfCliente ||
        "";

      // Remove qualquer máscara
      cpf = (cpf || "").toString().replace(/\D/g, "");

      if (!cpf) {
        this.$store?.dispatch("showSnackbar", {
          text: "CPF do cliente não encontrado para consulta na iVertex.",
          color: "error",
        });
        return;
      }

      try {
        const response = await SonaxService.obterClientePorCpf(cpf);
        const cliente = response?.data;

        if (!cliente) {
          this.$store?.dispatch("showSnackbar", {
            text: "Nenhuma informação detalhada retornada para este cliente.",
            color: "error",
          });
          return;
        }

        // Guarda o objeto completo retornado para usar na atualização
        this.clienteIvertxAtual = cliente;

        // Preenche o formulário com o objeto retornado pela rota iVertex
        this.prepareEditClientContactForm(cliente);
        this.showEditClientContactDialog = true;
      } catch (error) {
        console.error("Erro ao buscar cliente na iVertex:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data ||
            "Erro ao buscar cliente na API iVertex pelo CPF.",
          color: "error",
        });
      }
    },

    /**
     * Preenche o formulário de edição de contato a partir de um objeto cliente.
     * Reutilizado tanto no diálogo quanto na barra lateral.
     */
    prepareEditClientContactForm(cliente) {
      if (!cliente) return;

      // Monta endereço apenas para visualização
      const logradouro =
        cliente.enderecoLogradouro ||
        cliente.logradouro ||
        cliente.EnderecoLogradouro ||
        "";
      const numero =
        cliente.enderecoNumero ||
        cliente.numero ||
        cliente.EnderecoNumero ||
        "";
      const complemento =
        cliente.enderecoComplemento ||
        cliente.complemento ||
        cliente.EnderecoComplemento ||
        "";
      const bairro =
        cliente.enderecoBairro ||
        cliente.bairro ||
        cliente.EnderecoBairro ||
        "";
      const cidade =
        cliente.enderecoCidade ||
        cliente.cidade ||
        cliente.EnderecoCidade ||
        "";
      const uf = cliente.enderecoUF || cliente.uf || cliente.EnderecoUF || "";
      const cep =
        cliente.enderecoCep || cliente.cep || cliente.EnderecoCep || "";

      const enderecoPartes = [
        [logradouro, numero].filter(Boolean).join(", "),
        complemento,
        [bairro, cidade].filter(Boolean).join(" - "),
        [uf, cep].filter(Boolean).join(" • "),
      ].filter((p) => p && p.trim().length > 0);

      this.editClientContactForm = {
        idCliente: cliente.idCliente || cliente.id || cliente.Id || null,
        celular: cliente.celular || cliente.Celular || "",
        telefone: cliente.telefone || cliente.Telefone || "",
        email: cliente.email || cliente.Email || "",
        endereco: enderecoPartes.join("\n"),
      };
    },

    /**
     * Envia os dados atualizados do contato do cliente para a API iVertex.
     * Enviamos o objeto completo retornado na consulta + as edições de
     * Celular, Telefone e Email feitas no diálogo.
     */
    async atualizarContatoCliente() {
      if (!this.editClientContactForm.idCliente) {
        this.$store?.dispatch("showSnackbar", {
          text: "Identificador do cliente não encontrado.",
          color: "error",
        });
        return;
      }

      this.updatingClientContact = true;

      // Garante que temos a base retornada pela iVertex
      const base =
        this.clienteIvertxAtual && Object.keys(this.clienteIvertxAtual).length
          ? this.clienteIvertxAtual
          : {};

      // Remove máscara dos telefones antes de enviar
      const celularLimpo = (this.editClientContactForm.celular || "")
        .toString()
        .replace(/\D/g, "");
      const telefoneLimpo = (this.editClientContactForm.telefone || "")
        .toString()
        .replace(/\D/g, "");

      const payload = {
        ...base,
        Id:
          this.editClientContactForm.idCliente ||
          base.Id ||
          base.id ||
          base.idCliente,
        Celular: celularLimpo,
        Telefone: telefoneLimpo,
        Email: this.editClientContactForm.email,
      };

      try {
        const response = await SonaxService.atualizarCliente(payload);

        const message =
          response?.data?.message ||
          "Operação efetuada com sucesso. (Confirmado)";

        // Guarda mensagem e mostra diálogo de confirmação
        this.clientUpdateResultMessage = message;
        this.showClientUpdateResultDialog = true;

        this.showEditClientContactDialog = false;
      } catch (error) {
        console.error("Erro ao atualizar cliente na iVertex:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data ||
            "Erro ao atualizar os dados do cliente na API iVertex.",
          color: "error",
        });
      } finally {
        this.updatingClientContact = false;
      }
    },

    // Método para atualizar as informações do cliente selecionado
    updateSelectedClientInfo(protocolos = []) {
      if (
        this.clients.length > 0 &&
        this.selectedClientIndex >= 0 &&
        this.selectedClientIndex < this.clients.length
      ) {
        this.clientInfo = this.clients[this.selectedClientIndex];
        this.clientInfo.protocolos = protocolos;
      } else {
        this.clientInfo = null;
      }
    },

    // Método para mudar o cliente selecionado
    changeSelectedClient(index) {
      if (index >= 0 && index < this.clients.length) {
        this.selectedClientIndex = index;
        this.updateSelectedClientInfo(this.clientInfo?.protocolos || []);
      }
    },

    // Formatar CPF (XXX.XXX.XXX-XX)
    formatCpf(cpf) {
      if (!cpf) return "Não informado";

      const cpfClean = cpf.replace(/\D/g, "");
      if (cpfClean.length !== 11) return cpf;

      const initialDigits = cpfClean.slice(0, 3);
      const lastDigits = cpfClean.slice(-2);

      return `${initialDigits}.***.***-${lastDigits}`;
    },

    formatDate(date) {
      if (!date || date === "1900-01-01") return "Não informado";

      // Verificar se a data já está no formato brasileiro
      if (date.includes("/")) return date;

      // Converter para formato brasileiro
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateBR(date) {
      if (!date) return "Não informado";

      // Converter para formato brasileiro
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    getVencimentoColor(dataVencimento, status) {
      if (!dataVencimento) return "grey";

      // Se já foi pago ou quitado
      if (
        status &&
        (status.toLowerCase().includes("pago") ||
          status.toLowerCase().includes("quitado"))
      ) {
        return "success";
      }

      // Verificar se está vencido
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      if (vencimento < hoje) {
        return "error";
      } else {
        return "success";
      }
    },

    // Determinar texto do status de vencimento
    getVencimentoStatus(dataVencimento, status) {
      if (!dataVencimento) return "Sem data";

      // Verificar se está vencido
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      console.log(hoje);
      console.log(vencimento);

      if (vencimento < hoje) {
        return "Vencido";
      } else {
        // Está dentro do prazo
        return "A vencer";
      }
    },

    // Buscar status de leitura de todas as mensagens enviadas
    // Comentado temporariamente
    /*
    async fetchMessagesReadStatus() {
      if (!this.currentProtocol) return;

      try {
        // Buscar status apenas para mensagens enviadas (outgoing) que têm ID
        const outgoingMessages = this.messages.filter(
          (m) => m.direction === "outgoing" && m._id
        );

        if (outgoingMessages.length === 0) {
          console.log("Nenhuma mensagem enviada para buscar status");
          return;
        }

        console.log(`Buscando status de ${outgoingMessages.length} mensagens enviadas`);

        // Buscar status de todas as mensagens enviadas em paralelo
        const statusPromises = outgoingMessages.map(async (message, index) => {
          try {
            const statusResponse = await SonaxService.getMessageStatus(
              this.currentProtocol,
              message._id
            );

            console.log(`Status recebido para mensagem ${message._id}:`, statusResponse.data);

            if (
              statusResponse.data &&
              !statusResponse.data.error &&
              statusResponse.data.data
            ) {
              const statusData = statusResponse.data.data;

              // Encontrar o índice da mensagem no array original
              const messageIndex = this.messages.findIndex(
                (m) => m._id === message._id
              );

              if (messageIndex !== -1) {
                // Atualizar usando $set no array para garantir reatividade
                this.$set(this.messages[messageIndex], "isDelivered", statusData.isDelivered);
                this.$set(this.messages[messageIndex], "isRead", statusData.isRead);
                this.$set(this.messages[messageIndex], "deliveredAt", statusData.deliveredAt);
                this.$set(this.messages[messageIndex], "readAt", statusData.readAt);

                // Determinar status baseado em isRead e isDelivered
                let readStatus = "sent";
                if (statusData.isRead) {
                  readStatus = "read";
                } else if (statusData.isDelivered) {
                  readStatus = "delivered";
                }
                this.$set(this.messages[messageIndex], "readStatus", readStatus);

                console.log(`Status atualizado para mensagem ${message._id}:`, {
                  isRead: statusData.isRead,
                  isDelivered: statusData.isDelivered,
                  readStatus: readStatus
                });
              }
            }
          } catch (error) {
            // Ignorar erros individuais de status para não bloquear
            console.warn(
              `Erro ao buscar status da mensagem ${message._id}:`,
              error
            );
          }
        });

        // Aguardar todas as consultas de status
        await Promise.all(statusPromises);
        console.log("Status de todas as mensagens atualizado");
      } catch (error) {
        console.error("Erro ao buscar status de leitura:", error);
      }
    },
    */

    // Buscar protocolos (abertos/fechados) dos últimos 3 dias,
    // filtrando também pela fila selecionada (quando houver)
    async fetchOpenProtocols(ativarDialog = true) {
      // Validar se uma empresa foi selecionada
      if (!this.selectedEmpresa) {
        this.$store?.dispatch("showSnackbar", {
          text: "Por favor, selecione uma empresa no filtro antes de buscar protocolos.",
          color: "warning",
        });
        return;
      }

      if (ativarDialog) {
        this.loadingProtocols = true;
      }
      console.log("selectedFilaId", this.selectedFilaId);

      try {
        // Calcular datas para os últimos 3 dias
        const today = new Date();
        const threeDaysAgo = new Date(today);
        threeDaysAgo.setDate(today.getDate() - 3);

        // Formatar datas como YYYY-MM-DD
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const dtInicio = formatDate(threeDaysAgo);
        const dtFim = formatDate(today);

        const response = await SonaxService.getProtocolsByStatus(
          dtInicio,
          dtFim,
          this.protocolStatusFilter,
          this.telefoneEmpresa,
          this.selectedEmpresa,
          this.selectedFilaId || null,
        );

        if (response.data && !response.data.error && response.data.data) {
          // Armazenar todos os protocolos (abertos e fechados)
          // O filtro por status será aplicado no computed filteredProtocols
          this.openProtocols = response.data.data;
        }
      } catch (error) {
        console.error("Erro ao buscar protocolos:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar protocolos",
          color: "error",
        });
      } finally {
        this.loadingProtocols = false;
      }
    },

    // Selecionar um protocolo para visualização
    async selectProtocol(protocol) {
      // Parar qualquer consulta periódica anterior
      this.stopMessagePolling();

      // Armazenar dados do protocolo selecionado
      this.selectedProtocolData = protocol;
      this.currentProtocol = protocol.protocolo;
      // Limpar mensagens históricas ao selecionar um novo protocolo
      this.historicalMessages = [];
      // Ocultar a exibição das mensagens históricas
      this.showingHistoricalMessages = false;

      // Buscar mensagens do protocolo
      await this.fetchMessages();
      this.scrollToBottom(true);

      // Iniciar consulta periódica
      this.startMessagePolling();

      // Atualizar a lista de protocolos
      this.fetchOpenProtocols(false);
    },

    // Limpar seleção do protocolo atual
    async clearProtocolSelection() {
      // Parar consulta periódica
      this.stopMessagePolling();

      // Limpar dados do protocolo atual
      this.currentProtocol = null;
      this.currentProtocolId = null;
      this.selectedProtocolData = null;
      this.messages = [];
      this.historicalMessages = [];
      this.showingHistoricalMessages = false;

      // Atualizar a lista de protocolos
      await this.fetchOpenProtocols();
    },

    // Fechar diálogo de erro de vinculação e atualizar protocolos
    async closeVinculacaoErrorDialog() {
      this.showVinculacaoErrorDialog = false;
      this.vinculacaoErrorMessage = "";
      // Limpar protocolo atual
      await this.clearProtocolSelection();
    },

    // Confirmar fechamento de protocolo
    confirmCloseProtocol() {
      this.showCloseProtocolConfirmDialog = true;
    },

    // Fechar diálogo de confirmação
    cancelCloseProtocol() {
      this.showCloseProtocolConfirmDialog = false;
    },

    // Executar fechamento de protocolo
    async executeCloseProtocol() {
      this.showCloseProtocolConfirmDialog = false;

      if (!this.currentProtocolId) {
        this.$nextTick(() => {
          this.$store?.dispatch("showSnackbar", {
            text: "ID do protocolo não encontrado",
            color: "error",
          });
        });
        return;
      }

      this.closingProtocol = true;

      try {
        // Obter telefone do protocolo selecionado (to)
        let to = null;
        if (this.selectedProtocolData?.numeroDoContato) {
          to = this.selectedProtocolData.numeroDoContato;
          // Garantir que tenha o prefixo 55
          if (!to.startsWith("55")) {
            to = `55${to.replace(/^\+?55/, "")}`;
          }
        }

        // Obter from (número do broker) - usar o mesmo padrão do envio de mensagens
        const from = this.selectedTemplate
          ? this.selectedTemplate.brokerNumber
          : this.telefoneEmpresa;

        if (!to) {
          this.$store?.dispatch("showSnackbar", {
            text: "Número de telefone não encontrado",
            color: "error",
          });
          this.closingProtocol = false;
          return;
        }

        const response = await SonaxService.closeProtocol(
          this.currentProtocolId,
          this.currentProtocol,
          to,
          from,
        );

        if (response.data && !response.data.error) {
          this.$nextTick(() => {
            this.$store?.dispatch("showSnackbar", {
              text: "Protocolo fechado com sucesso",
              color: "success",
            });
          });

          // Parar a consulta periódica
          this.stopMessagePolling();

          // Limpar protocolo atual
          this.currentProtocol = null;
          this.currentProtocolId = null;
          this.selectedProtocolData = null;
          this.messages = [];

          // Atualizar a lista de protocolos
          this.fetchOpenProtocols();
        } else {
          this.$nextTick(() => {
            this.$store?.dispatch("showSnackbar", {
              text: response.data?.message || "Erro ao fechar protocolo",
              color: "error",
            });
          });
        }
      } catch (error) {
        console.error("Erro ao fechar protocolo:", error);
        this.$nextTick(() => {
          this.$store?.dispatch("showSnackbar", {
            text: error.response?.data?.message || "Erro ao fechar protocolo",
            color: "error",
          });
        });
      } finally {
        this.closingProtocol = false;
      }
    },

    // Vincular atendimento ao protocolo
    async vincularAtendimento() {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não encontrado",
          color: "error",
        });
        return;
      }

      this.linkingAttendance = true;

      try {
        const response = await SonaxService.vincularAtendimento(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Atendimento vinculado com sucesso",
            color: "success",
          });

          // Atualizar a lista de protocolos para refletir a mudança
          await this.fetchOpenProtocols(false);

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }
        } else {
          // Se for erro de protocolo já vinculado a outro atendente, mostrar diálogo
          if (
            response.data?.error &&
            response.data?.message &&
            response.data.message.includes("já está vinculado")
          ) {
            this.vinculacaoErrorMessage = response.data.message;
            this.showVinculacaoErrorDialog = true;
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: response.data?.message || "Erro ao vincular atendimento",
              color: "error",
            });
          }
        }
      } catch (error) {
        console.error("Erro ao vincular atendimento:", error);

        // Verificar se o erro é de protocolo já vinculado
        const errorMessage = error.response?.data?.message || "";
        if (errorMessage.includes("já está vinculado")) {
          this.vinculacaoErrorMessage = errorMessage;
          this.showVinculacaoErrorDialog = true;
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: errorMessage || "Erro ao vincular atendimento",
            color: "error",
          });
        }
      } finally {
        this.linkingAttendance = false;
      }
    },

    // Desvincular atendimento do protocolo
    async desvincularAtendimento() {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não encontrado",
          color: "error",
        });
        return;
      }

      this.unlinkingAttendance = true;

      try {
        const response = await SonaxService.desvincularAtendimento(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Atendimento desvinculado com sucesso",
            color: "success",
          });

          // Limpar seleção do protocolo atual
          await this.clearProtocolSelection();

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao desvincular atendimento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao desvincular atendimento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao desvincular atendimento",
          color: "error",
        });
      } finally {
        this.currentProtocol = null;
        this.fetchOpenProtocols();
        this.unlinkingAttendance = false;
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("pt-BR");
    },

    stripHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },

    // Abrir diálogo de transferência de atendimento
    abrirDialogTransferencia() {
      this.showTransferDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },

    // Carregar lista de colaboradores ativos
    async carregarColaboradores() {
      this.loadingColaboradores = true;
      try {
        console.log(this.selectedEmpresa);
        const response = await UsuarioService.todos_ativos_com_colaborador(
          this.selectedEmpresa,
        );

        if (response.data && Array.isArray(response.data)) {
          // Filtrar o usuário logado da lista de colaboradores
          const usuarioLogado = this.loggedUserName;

          this.colaboradores = response.data
            .filter((colaborador) => colaborador.nome !== usuarioLogado) // Remove o usuário logado da lista
            .map((colaborador) => ({
              id: colaborador.id,
              nome: colaborador.nome,
              email: colaborador.email,
              departamento: colaborador.departamento || "Não informado",
            }));

          console.log(
            `Filtrado usuário logado: ${usuarioLogado}. Total de colaboradores: ${this.colaboradores.length}`,
          );
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao carregar colaboradores: Formato de dados inválido",
            color: "error",
          });
          this.colaboradores = [];
        }
      } catch (error) {
        console.error("Erro ao carregar colaboradores:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao carregar colaboradores",
          color: "error",
        });
        this.colaboradores = [];
      } finally {
        this.loadingColaboradores = false;
      }
    },

    // Executar transferência de atendimento
    async executarTransferencia() {
      if (!this.selectedColaboradores.length || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um colaborador para transferir o atendimento",
          color: "warning",
        });
        return;
      }

      const colaboradorSelecionado = this.selectedColaboradores[0];
      this.transferringAttendance = true;

      try {
        const response = await SonaxService.transferirAtendimento(
          this.currentProtocol,
          colaboradorSelecionado.nome,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `Atendimento transferido com sucesso para ${colaboradorSelecionado.nome}`,
            color: "success",
          });

          // Limpar seleção do protocolo atual
          await this.clearProtocolSelection();

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }

          // Fechar o diálogo
          this.showTransferDialog = false;
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao transferir atendimento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao transferir atendimento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao transferir atendimento",
          color: "error",
        });
      } finally {
        this.transferringAttendance = false;
        this.currentProtocol = null;
        this.fetchOpenProtocols();
      }
    },

    // Abrir diálogo de adicionar participante
    abrirDialogParticipante() {
      this.showParticipantDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },

    // Adicionar participante ao atendimento
    async adicionarParticipante() {
      const protocoloAtual = this.currentProtocol;
      if (!this.selectedColaboradores.length || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um colaborador para adicionar como participante",
          color: "warning",
        });
        return;
      }

      const colaboradorSelecionado = this.selectedColaboradores[0];
      this.addingParticipant = true;

      try {
        const response = await SonaxService.adicionarVisitante(
          this.currentProtocol,
          colaboradorSelecionado.nome,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `${colaboradorSelecionado.nome} adicionado como participante com sucesso`,
            color: "success",
          });

          // Fechar o diálogo
          this.showParticipantDialog = false;
          this.selectedColaboradores = [];
          this.searchColaborador = "";

          // Atualizar a lista de protocolos
          await this.fetchOpenProtocols();

          // Atualizar o selectedProtocolData para refletir a mudança
          if (this.currentProtocol) {
            const updatedProtocol = this.openProtocols.find(
              (p) => p.protocolo === this.currentProtocol,
            );
            if (updatedProtocol) {
              // Forçar a atualização do selectedProtocolData
              this.selectedProtocolData = { ...updatedProtocol };
              console.log(
                "SelectedProtocolData atualizado:",
                this.selectedProtocolData,
              );
            }
          }

          // Atualizar mensagens para mostrar a notificação de novo participante
          this.refreshMessages();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao adicionar participante",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao adicionar participante:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao adicionar participante",
          color: "error",
        });
      } finally {
        this.addingParticipant = false;
      }
    },

    // Abrir diálogo de transferência de fila
    abrirDialogTransferenciaFila() {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Nenhum protocolo selecionado",
          color: "warning",
        });
        return;
      }

      if (!this.filas || !this.filas.length) {
        this.$store?.dispatch("showSnackbar", {
          text: "Nenhuma fila disponível para transferência",
          color: "warning",
        });
        return;
      }

      this.filaDestinoSelecionada = null;
      this.showTransferFilaDialog = true;
    },

    // Fechar diálogo de transferência de fila
    fecharDialogTransferenciaFila() {
      this.showTransferFilaDialog = false;
      this.filaDestinoSelecionada = null;
      this.transferindoFila = false;
    },

    // Executar transferência de fila
    async executarTransferenciaFila() {
      if (!this.filaDestinoSelecionada || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione uma fila de destino",
          color: "warning",
        });
        return;
      }

      this.transferindoFila = true;

      try {
        const response = await SonaxService.transferirAtendimentoFila(
          this.currentProtocol,
          this.filaDestinoSelecionada,
        );

        if (response.data && !response.data.error) {
          const filaDestino = this.filas.find(
            (f) => f.id === this.filaDestinoSelecionada,
          );

          this.$store?.dispatch("showSnackbar", {
            text: `Protocolo transferido com sucesso para a fila "${
              filaDestino?.nomeFila || "selecionada"
            }"`,
            color: "success",
          });

          // Fechar o diálogo
          this.fecharDialogTransferenciaFila();

          // Limpar seleção do protocolo atual
          await this.clearProtocolSelection();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao transferir fila",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao transferir fila:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao transferir fila",
          color: "error",
        });
      } finally {
        this.transferindoFila = false;
      }
    },

    // Abrir diálogo de confirmação para remover participante
    confirmRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = true;
    },

    // Abrir diálogo de confirmação para sair do atendimento
    confirmExitAttendance() {
      this.showExitAttendanceConfirmDialog = true;
    },

    // Cancelar saída do atendimento
    cancelExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;
    },

    // Executar saída do atendimento
    async executeExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;

      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      await this.desvincularAtendimento();
    },

    // Cancelar remoção de participante ou saída do atendimento
    cancelRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = false;
    },

    // Executar remoção de participante ou saída do atendimento
    async executeRemoveParticipant(isAtendente) {
      this.showRemoveParticipantConfirmDialog = false;

      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      await this.removerParticipante(isAtendente);
    },

    // Remover participante do atendimento
    async removerParticipante(isAtendente) {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      const protocoloAtual = this.currentProtocol;
      this.removingParticipant = true;

      try {
        const response = await SonaxService.removerVisitante(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `Participante removido com sucesso`,
            color: "success",
          });

          // Atualizar a lista de protocolos
          await this.fetchOpenProtocols();
          if (isAtendente) {
            // Atualizar o selectedProtocolData para refletir a mudança
            // Manter o protocolo atual selecionado em vez de limpá-lo
            if (protocoloAtual) {
              const updatedProtocol = this.openProtocols.find(
                (p) => p.protocolo === protocoloAtual,
              );
              if (updatedProtocol) {
                // Forçar a atualização do selectedProtocolData
                this.selectedProtocolData = { ...updatedProtocol };
                console.log(
                  "SelectedProtocolData atualizado após remover participante:",
                  this.selectedProtocolData,
                );
              }
            }
          } else {
            this.currentProtocol = null;
          }

          // Atualizar mensagens
          this.refreshMessages();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao remover participante",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao remover participante:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao remover participante",
          color: "error",
        });
      } finally {
        this.removingParticipant = false;
      }
    },

    // Abrir diálogo de seleção de forma de pagamento
    abrirDialogSelecaoFormaPagamento(idDocumento) {
      this.idDocumentoSelecionado = idDocumento;
      this.showSelecaoFormaPagamentoDialog = true;
    },

    // Fechar diálogo de seleção de forma de pagamento
    closeSelecaoFormaPagamentoDialog() {
      // Não permite fechar durante o loading
      if (this.loadingFormaPagamento !== null) {
        return;
      }
      this.showSelecaoFormaPagamentoDialog = false;
      this.idDocumentoSelecionado = null;
    },

    // Selecionar forma de pagamento e chamar o método
    async selecionarFormaPagamento(formaPagamento) {
      // Não permite selecionar durante o loading
      if (this.loadingFormaPagamento !== null) {
        return;
      }

      // Salvar o ID antes de fechar o diálogo (que limpa a variável)
      const idDocumento = this.idDocumentoSelecionado;
      const protocolo = this.currentProtocol;

      // Mapear o label exibido para o valor que o backend espera
      let formaPagamentoParaEnviar = formaPagamento;
      if (formaPagamento === "PDF Boleto") {
        formaPagamentoParaEnviar = "PDF";
      } else if (formaPagamento === "Link de Pagamento") {
        formaPagamentoParaEnviar = "Link";
      } else if (formaPagamento === "Código de Barras") {
        formaPagamentoParaEnviar = "Barras";
      }
      // "Pix" permanece como "Pix"

      if (idDocumento) {
        // Não fecha o diálogo ainda, mantém aberto para mostrar o loading
        await this.gerarFormaPagamento(
          idDocumento,
          formaPagamentoParaEnviar,
          protocolo,
        );
        // Fechar o diálogo após o processamento (sucesso ou erro)
        this.closeSelecaoFormaPagamentoDialog();
      } else {
        this.$store?.dispatch("showSnackbar", {
          text: "ID do documento não encontrado",
          color: "error",
        });
      }
    },

    // Gerar forma de pagamento
    async gerarFormaPagamento(idDocumento, formaPagamento, protocolo) {
      if (!idDocumento) {
        this.$store?.dispatch("showSnackbar", {
          text: "ID do documento não encontrado",
          color: "error",
        });
        return;
      }

      if (!formaPagamento) {
        this.$store?.dispatch("showSnackbar", {
          text: "Forma de pagamento não selecionada",
          color: "error",
        });
        return;
      }

      this.loadingFormaPagamento = idDocumento;

      try {
        // Obter telefone do protocolo selecionado (remover prefixo 55 se existir)
        let telefone = null;
        if (this.selectedProtocolData?.numeroDoContato) {
          telefone = this.selectedProtocolData.numeroDoContato.replace(
            /^\+?55/,
            "",
          );
        }

        // Obter from (número do broker) - usar o mesmo padrão do envio de mensagens
        const from = this.selectedTemplate
          ? this.selectedTemplate.brokerNumber
          : this.telefoneEmpresa;

        const response = await SonaxService.gerarFormaPagamento(
          idDocumento,
          telefone,
          from,
          formaPagamento,
          protocolo,
        );

        if (response.data) {
          // Se tiver mensagem, exibir no diálogo
          if (response.data.message) {
            this.formaPagamentoResponse = response.data.message;
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
            // Atualizar o chat após gerar forma de pagamento
            if (this.currentProtocol) {
              await this.fetchMessagesWithoutLoading();
            }
          }
          // Se tiver formaPagamento vazio, exibir mensagem de erro no diálogo
          else if (
            response.data.formaPagamento !== undefined &&
            response.data.formaPagamento === ""
          ) {
            this.formaPagamentoResponse =
              "Esta forma de pagamento não está habilitada para este documento.";
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
          }
          // Se tiver formaPagamento (URL), exibir no diálogo com opções
          else if (response.data.formaPagamento) {
            // Verificar se é um boleto PDF
            const isBoleto =
              response.data.formaPagamento.toLowerCase().includes("boleto") &&
              response.data.formaPagamento.toLowerCase().endsWith(".pdf");

            if (isBoleto) {
              // Abrir diálogo específico para boleto PDF
              this.boletoPdfUrl = response.data.formaPagamento;
              this.showBoletoPdfDialog = true;
            } else {
              // Outros tipos de forma de pagamento (Pix, Link, etc.)
              this.formaPagamentoResponse = null;
              this.formaPagamentoLink = response.data.formaPagamento;
              this.showFormaPagamentoDialog = true;
            }

            // Atualizar o chat após gerar forma de pagamento
            if (this.currentProtocol) {
              await this.fetchMessagesWithoutLoading();
            }
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: "Resposta inválida da API",
              color: "error",
            });
          }
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao gerar forma de pagamento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao gerar forma de pagamento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao gerar forma de pagamento",
          color: "error",
        });
      } finally {
        this.loadingFormaPagamento = null;
      }
    },

    // Fechar diálogo de forma de pagamento
    closeFormaPagamentoDialog() {
      this.showFormaPagamentoDialog = false;
      this.formaPagamentoResponse = null;
      this.formaPagamentoLink = null;
    },

    // Fechar diálogo de boleto PDF
    closeBoletoPdfDialog() {
      this.showBoletoPdfDialog = false;
      this.boletoPdfUrl = null;
    },

    // Enviar boleto PDF para o cliente
    async enviarBoletoParaCliente() {
      if (!this.boletoPdfUrl || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Erro: URL do boleto ou protocolo não encontrado",
          color: "error",
        });
        return;
      }

      this.sendingBoleto = true;

      try {
        // Obter o número do telefone do protocolo selecionado
        let phoneNumberToSend = this.phoneNumber;

        // Se phoneNumber estiver vazio, pegar do protocolo selecionado
        if (!phoneNumberToSend && this.selectedProtocolData) {
          phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
            /^\+?55/,
            "",
          );
        }

        // Se ainda estiver vazio, tentar pegar das mensagens
        if (!phoneNumberToSend && this.messages.length > 0) {
          const firstMessage = this.messages[0];
          if (firstMessage.to) {
            phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
          } else if (firstMessage.from) {
            phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
          }
        }

        if (!phoneNumberToSend) {
          this.$store?.dispatch("showSnackbar", {
            text: "Número de telefone não encontrado",
            color: "error",
          });
          return;
        }

        // Validar se uma empresa foi selecionada
        if (!this.selectedEmpresa) {
          this.$store?.dispatch("showSnackbar", {
            text: "Por favor, selecione uma empresa no filtro antes de enviar mensagens.",
            color: "warning",
          });
          return;
        }

        // Garantir que o número tenha o prefixo 55
        const telefoneFormatado = phoneNumberToSend.startsWith("55")
          ? phoneNumberToSend
          : `55${phoneNumberToSend}`;

        // Enviar boleto usando o link
        const response = await SonaxService.sendMessageFile({
          protocolo: this.currentProtocol,
          to: telefoneFormatado,
          empresa: this.selectedEmpresa,
          from: this.telefoneEmpresa,
          fileUrl: this.boletoPdfUrl,
        });

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Boleto enviado com sucesso!",
            color: "success",
          });

          // Fechar diálogo
          this.closeBoletoPdfDialog();

          // Atualizar mensagens
          await this.fetchMessagesWithoutLoading();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar boleto",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar boleto:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message ||
            error.message ||
            "Erro ao enviar boleto",
          color: "error",
        });
      } finally {
        this.sendingBoleto = false;
      }
    },

    // Copiar link da forma de pagamento para área de transferência
    async copiarLinkFormaPagamento() {
      if (!this.formaPagamentoLink) return;

      try {
        await navigator.clipboard.writeText(this.formaPagamentoLink);
        this.$store?.dispatch("showSnackbar", {
          text: "Link copiado para a área de transferência",
          color: "success",
        });
      } catch (error) {
        console.error("Erro ao copiar link:", error);
        // Fallback para navegadores mais antigos
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoLink;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$store?.dispatch("showSnackbar", {
            text: "Link copiado para a área de transferência",
            color: "success",
          });
        } catch (err) {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar link",
            color: "error",
          });
        }
        document.body.removeChild(textArea);
      }
    },

    // Copiar texto da mensagem de forma de pagamento
    async copiarTextoFormaPagamento() {
      if (!this.formaPagamentoResponse) return;

      try {
        await navigator.clipboard.writeText(this.formaPagamentoResponse);
        this.$store?.dispatch("showSnackbar", {
          text: "Texto copiado para a área de transferência",
          color: "success",
        });
      } catch (error) {
        console.error("Erro ao copiar texto:", error);
        // Fallback para navegadores mais antigos
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoResponse;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$store?.dispatch("showSnackbar", {
            text: "Texto copiado para a área de transferência",
            color: "success",
          });
        } catch (err) {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar texto",
            color: "error",
          });
        }
        document.body.removeChild(textArea);
      }
    },

    // Enviar mensagem com o link da forma de pagamento
    async enviarMensagemFormaPagamento() {
      if (!this.formaPagamentoLink || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Link ou protocolo não encontrado",
          color: "error",
        });
        return;
      }

      // Validar se uma empresa foi selecionada
      if (!this.selectedEmpresa) {
        this.$store?.dispatch("showSnackbar", {
          text: "Por favor, selecione uma empresa no filtro antes de enviar mensagens.",
          color: "warning",
        });
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        const messageData = {
          message: this.formaPagamentoLink,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : this.telefoneEmpresa,
          empresa: this.selectedEmpresa,
          paramsTemplate: "", // String vazia indica que é texto livre
          primeiroContato: false,
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Mensagem enviada com sucesso",
            color: "success",
          });

          // Atualizar mensagens
          await this.fetchMessagesWithoutLoading();

          // Fechar diálogo
          this.closeFormaPagamentoDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    // Enviar mensagem com o texto da forma de pagamento
    async enviarMensagemTextoFormaPagamento() {
      if (!this.formaPagamentoResponse || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Mensagem ou protocolo não encontrado",
          color: "error",
        });
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        const messageData = {
          message: this.formaPagamentoResponse,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : this.telefoneEmpresa,
          empresa: this.selectedEmpresa,
          paramsTemplate: "", // String vazia indica que é texto livre
          primeiroContato: false,
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Mensagem enviada com sucesso",
            color: "success",
          });

          // Atualizar mensagens
          await this.fetchMessagesWithoutLoading();

          // Fechar diálogo
          this.closeFormaPagamentoDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    // Abrir diálogo de interações
    abrirDialogInteracoes() {
      this.showInteracoesDialog = true;
      this.definirPeriodoPadrao();
      this.buscarInteracoes();
    },

    // Fechar diálogo de interações
    closeInteracoesDialog() {
      this.showInteracoesDialog = false;
      this.interacoes = [];
      this.searchInteracoes = "";
    },

    // Definir período padrão (mês atual)
    definirPeriodoPadrao() {
      const hoje = new Date();
      const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

      // Formato ISO (YYYY-MM-DD) para consulta na API
      this.filtroDataInicio = this.formatDateISO(primeiroDiaMes);
      this.filtroDataFim = this.formatDateISO(ultimoDiaMes);
    },

    // Formatar data no formato ISO (YYYY-MM-DD)
    formatDateISO(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // Buscar interações
    async buscarInteracoes() {
      if (!this.filtroDataInicio || !this.filtroDataFim) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione o período para buscar as interações",
          color: "warning",
        });
        return;
      }

      this.loadingInteracoes = true;

      try {
        const response = await SonaxService.getInteracoes(
          this.filtroDataInicio,
          this.filtroDataFim,
        );

        if (response.data) {
          this.interacoes = response.data.map((item) => ({
            ...item,
            // Garantir que todos os campos necessários existam
            idInteracao: item.idInteracao || 0,

            dtInteracao: item.dtInteracao || new Date().toISOString(),
            cliente: item.cliente || "Não informado",
            telefone: item.telefone || "-",
            status: item.status || "Pendente",
          }));
        } else {
          this.interacoes = [];
          this.$store?.dispatch("showSnackbar", {
            text: "Nenhuma interação encontrada",
            color: "info",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar interações:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar interações",
          color: "error",
        });
        this.interacoes = [];
      } finally {
        this.loadingInteracoes = false;
      }
    },

    // Obter cor para o status da interação
    getStatusColor(status) {
      const statusMap = {
        Pendente: "warning",
        "Em Andamento": "info",
        Concluído: "success",
        Cancelado: "error",
        Transferido: "purple",
      };

      return statusMap[status] || "grey";
    },

    // Selecionar telefone da interação
    selecionarTelefone(telefone, item) {
      if (telefone) {
        // Remover o prefixo +55 se existir
        this.phoneNumber = telefone;

        // Armazenar a interação selecionada
        this.selectedInteracao = item;

        this.closeInteracoesDialog();
      } else {
        this.$store?.dispatch("showSnackbar", {
          text: "Telefone não disponível",
          color: "warning",
        });
      }
    },

    // Obter referência do textarea
    getTextarea() {
      return document.querySelector(".message-input-area textarea");
    },

    // Formatar texto (negrito, itálico, sublinhado)
    formatar(tipo) {
      const textarea = this.getTextarea();
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Se não há texto selecionado, não faz nada
      if (start === end) return;

      const texto = this.freeTextMessage;
      const selecionado = texto.slice(start, end);

      // Define os marcadores por tipo
      const markers = {
        bold: "*",
        italic: "_",
        underline: "~",
      };

      const m = markers[tipo];

      let novo = selecionado;

      // Se já está formatado, remove a formatação
      if (selecionado.startsWith(m) && selecionado.endsWith(m)) {
        novo = selecionado.substring(1, selecionado.length - 1);
      } else {
        // Senão, adiciona a formatação
        novo = `${m}${selecionado}${m}`;
      }

      // Aplica a mudança no texto
      this.freeTextMessage = texto.slice(0, start) + novo + texto.slice(end);

      // Mantém a seleção após a formatação
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = start;
        textarea.selectionEnd = start + novo.length;
      });
    },

    // Métodos para o emoji picker
    async toggleEmojiPicker() {
      // Carrega o emoji picker se ainda não foi carregado
      await loadEmojiPicker();
    },

    closeEmojiPicker() {
      this.showEmojiPicker = false;
    },

    onEmojiClick(event) {
      // Insere o emoji na posição atual do cursor ou no final do texto
      const emoji = event.detail.unicode;
      this.freeTextMessage += emoji;

      // Fecha o emoji picker após selecionar um emoji
      this.showEmojiPicker = false;
    },

    // Métodos para identificar tipos de arquivos
    isImage(url) {
      if (!url) return false;
      return /\.(jpg|jpeg|png|gif|webp|bmp|svg)($|\?)/i.test(url);
    },

    isAudio(url) {
      if (!url) return false;
      return /\.(mp3|ogg|wav|m4a|aac|flac|opus)($|\?)/i.test(url);
    },

    isVideo(url) {
      if (!url) return false;
      return /\.(mp4|webm|mov|m4v|avi|mkv|3gp)($|\?)/i.test(url);
    },

    // Método para abrir a pré-visualização de mídia
    openMediaPreview(url) {
      if (!url) return;
      // Abre o arquivo em uma nova aba
      window.open(url, "_blank");
    },

    // Método para abrir o diálogo de protocolo com mensagens
    async abrirProtocolo(protocolo) {
      if (!protocolo || !protocolo.protocolNumber) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo inválido",
          color: "error",
        });
        return;
      }

      this.protocolMessagesLoading = true;
      this.protocolMessagesData = protocolo;
      this.showProtocolMessagesDialog = true;
      this.selectedProtocolMessages = [];

      try {
        const response = await SonaxService.getMessages(
          protocolo.protocolNumber,
        );

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          this.selectedProtocolMessages = this.processarStatusMensagens(
            response.data.data,
          );
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao carregar mensagens do protocolo",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens do protocolo:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message ||
            "Erro ao buscar mensagens do protocolo",
          color: "error",
        });
      } finally {
        this.protocolMessagesLoading = false;
      }
    },

    // Fechar diálogo de mensagens do protocolo
    closeProtocolMessagesDialog() {
      this.showProtocolMessagesDialog = false;
      this.protocolMessagesData = null;
      this.selectedProtocolMessages = [];
    },

    // Scroll automático para o final do chat com estratégia multifásica (evita parar no meio em textos longos)
    scrollToBottom(force = false) {
      const scrollAction = () => {
        const chatContainer =
          document.querySelector(".chat-panel .chat-container") ||
          document.querySelector(".chat-container");
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
        if (
          this.$refs.chatBottomAnchor &&
          typeof this.$refs.chatBottomAnchor.scrollIntoView === "function"
        ) {
          this.$refs.chatBottomAnchor.scrollIntoView({
            block: "end",
            behavior: "auto",
          });
        }
      };

      this.$nextTick(() => {
        scrollAction();
        if (typeof window !== "undefined" && window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            scrollAction();
            window.requestAnimationFrame(scrollAction);
          });
        }
        setTimeout(scrollAction, 50);
        setTimeout(scrollAction, 150);
        setTimeout(scrollAction, 300);
        if (force) {
          setTimeout(scrollAction, 600);
          setTimeout(scrollAction, 1000);
        }
      });
    },
  },
};
</script>

<style scoped>
.emoji-picker-container {
  max-height: 350px;
  overflow-y: auto;
  z-index: 9999;
}

.file-message {
  margin: 5px 0;
}

.file-message img {
  max-width: 100%;
  border-radius: 4px;
  transition: transform 0.2s;
}

.file-message img:hover {
  transform: scale(1.02);
}

.media-container {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.media-icon {
  font-size: 24px;
}

.audio-player {
  width: 250px;
  height: 40px;
  border-radius: 20px;
  outline: none;
}

.chat-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.message-bubble {
  max-width: 70%;
  border-radius: 8px;
  word-break: break-word;
}

.outgoing-message {
  background-color: #cfe8ff;
  border-left: 3px solid #1565c0;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message {
  background-color: #eceff1;
  border-right: 3px solid #90a4ae;
  margin-right: auto;
  border-top-left-radius: 0;
}

.outgoing-message-historico {
  background-color: #e6f3ff;
  border-left: 3px solid #90caf9;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message-historico {
  background-color: #e8f5e9;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}
.chat-card {
  min-height: 500px;
}

.protocols-card {
  min-height: 500px;
}

.protocols-list-container {
  max-height: 100%;
  overflow-y: auto;
}

.client-details-card {
  min-height: 500px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}

.message-bubble.note-message {
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #555;
  font-style: italic;
  max-width: 90%;
  margin: 0 auto;
  text-align: center;
}

.text-formatting-buttons {
  display: flex;
  gap: 4px;
  margin-left: 2px;
}

.note-message {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

.note-message-historico {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

/* Gravador de áudio */
.audio-recorder-container {
  padding: 10px;
}

.audio-visualizer {
  height: 80px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.audio-visualizer.is-recording {
  background-color: rgba(244, 67, 54, 0.1);
}

.time-counter {
  font-size: 24px;
  font-weight: bold;
  color: #4caf50;
  margin-bottom: 10px;
}

.audio-visualizer.is-recording .time-counter {
  color: #f44336;
}

.wave-container {
  display: flex;
  align-items: center;
  height: 30px;
  gap: 4px;
}

.wave {
  width: 4px;
  height: 10px;
  background-color: #ccc;
  border-radius: 2px;
}

.audio-visualizer.is-recording .wave {
  background-color: #f44336;
  animation: wave 1s infinite ease-in-out;
}

.audio-visualizer.is-recording .wave:nth-child(1) {
  animation-delay: 0s;
}
.audio-visualizer.is-recording .wave:nth-child(2) {
  animation-delay: 0.2s;
}
.audio-visualizer.is-recording .wave:nth-child(3) {
  animation-delay: 0.4s;
}
.audio-visualizer.is-recording .wave:nth-child(4) {
  animation-delay: 0.6s;
}
.audio-visualizer.is-recording .wave:nth-child(5) {
  animation-delay: 0.8s;
}

@keyframes wave {
  0%,
  100% {
    height: 10px;
  }
  50% {
    height: 30px;
  }
}

.audio-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.audio-preview-player {
  width: 100%;
  max-width: 300px;
}
</style>
